import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  VStack,
  Button,
  SimpleGrid,
  Stack,
  Text,
  Card,
  CardBody,
  Image,
  Input,
  CardHeader,
  CardFooter,
  Select,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Flex,
  GridItem,
  Grid,
  ButtonGroup,
  OrderedList,
  ListItem,
  useDisclosure,
  InputGroup,
  InputLeftAddon,
  FormLabel,
  Checkbox,
  InputRightAddon,
} from "@chakra-ui/react";
import { MdArrowDropDown } from "react-icons/md";
import { RxHalf2 } from "react-icons/rx";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import io from "socket.io-client";
import {
  FaPlus,
  FaMinus,
  FaRupeeSign,
  FaTrash,
  FaHome,
  FaPhone,
} from "react-icons/fa";
import axios from "axios";
import { useTableTime } from "../context/tableTimeContext";
import { useLocation } from "react-router-dom";

import { useReactToPrint } from "react-to-print";
import { fetchHappyHour } from "../../redux/reducers/happyHourReducer";

import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useBillItems } from "../context/tableItemsContext";
import toast from "react-hot-toast";
import UseKotPrint from "./kot";
import { useFoodItems } from "../context/foodItemsContext";
import { numberToWords } from "../utils/numberToWords";
import HalfPlateModal from "./halfPlateModal";
import UpdateKotPrint from "./kotUpdate";
import { useKotContext } from "../context/kotContext";
import { FaWineBottle } from "react-icons/fa";
import FullBottleModal from "./fullBottleModal";
import { set } from "lodash";
import NcPopup from "./PopUp";
import { useNcContext } from "../context/ncContext";
import { useSelector, useDispatch } from "react-redux";
import { getHappyHourStatus } from "../../redux/reducers/helper";
import { use } from "react";
//import { useLocation } from 'react-router-dom';
const socket = io("https://api.rasoi.launchlysoftware.in");

const RestaurentData = () => {
  const location = useLocation();
  const happyHourState = useSelector((state) => state.happyHour);
  const { isHappyHour, happyDiscount, timeRange } =
    getHappyHourStatus(happyHourState);
  const { onOpen, isOpen, onClose } = useDisclosure();
  const { fetchKotNo, kotNumber, serverName, updateServerName } =
    useKotContext();
  const { getNc, clearNc, ncData } = useNcContext();
  const [category, setCategory] = useState([]);
  const { startTimer } = useTableTime();
  const [foodData, setFoodData] = useState([]);
  const [hsnView, setHsnView] = useState(false);
  const [roundOff, setRoundOff] = useState(0);

  const [foodData1, setFoodData1] = useState([]);
  const [order, setOrder] = useState([]);
  const imageRefs = useRef({});
  const [page, setPage] = useState(1); // Current page for paginated data
  const [loading, setLoading] = useState(true); // Loading state
  const [hasMore, setHasMore] = useState(true); // Track if more data is available
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);
  const {
    isOpen: isFoodModalOpen,
    onOpen: onOpenFoodModal,
    onClose: onCloseFoodModal,
  } = useDisclosure();
  const {
    isOpen: isWineModalOpen,
    onOpen: onOpenWineModal,
    onClose: onCloseWineModal,
  } = useDisclosure();
  console.log(happyHourState, "happyHourState");
  console.log(timeRange, "timeRange");
  console.log(isHappyHour, "isHappyHour");
  console.log(serverName, "serverName");
  const navigate = useNavigate();

  const handleToggle = async (id) => {
    try {
      const item = filteredData.find((x) => x._id === id);
      if (!item) return;

      // Wine item (has purchaseRate)
      if (item.purchaseRate) {
        const res = await axios.get(
          `https://api.rasoi.launchlysoftware.in/api/getWineDataById/${customerId}/${id}`,
        );
        setFoodData(res.data.wine);
      }

      // Food item
      else {
        const res = await axios.get(
          `https://api.rasoi.launchlysoftware.in/api/getFoodDataById/${customerId}/${id}`,
        );
        setFoodData(res.data.food);
      }

      onOpenFoodModal(); // open HALF modal
    } catch (error) {
      console.error("Toggle error:", error);
    }
  };

  const categoryData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getFoodCategory/${customerId}`,
        {},
      );
      setCategory(response.data.foodCategory);
      //console.log(response.data.user)
    } catch (error) {
      //toast.error(error.message)
    }
  };
  const handleToggle1 = async (id) => {
    try {
      const item = filteredData.find((x) => x._id === id);
      if (!item) return;

      // Wine item full bottle
      if (item.purchaseRate) {
        const res = await axios.get(
          `https://api.rasoi.launchlysoftware.in/api/getWineDataById/${customerId}/${id}`,
        );
        setFoodData1(res.data.wine);
      }

      // Food item full (rare but handled)
      else {
        const res = await axios.get(
          `https://api.rasoi.launchlysoftware.in/api/getFoodDataById/${customerId}/${id}`,
        );
        setFoodData1(res.data.food);
      }

      onOpenWineModal(); // open FULL modal
    } catch (error) {
      console.error("Toggle error:", error);
    }
  };

  const { tableNo, ac } = location.state || {};
  //console.log(tableNo,ac,'a');
  const isAc = ac === "Ac";
  const isHalf = false;
  const isBottle = false;
  const {
    billItems,
    addToBill,
    updateQuantity,
    deleteItem,
    clearBill,
    fetchTableBillItems,
    setBillItems,
    updateNote,
    updateDiscount,
    updatePrice,
  } = useBillItems();
  // const {updateNote}=useBillItems()
  const { clearKotNo, clearServerName } = useKotContext();

  // Other state variables and functions remain the same
  const [data, setData] = useState([]);
  const [foodNote, setFoodNote] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [wineFilterData, setWineFilterData] = useState([]);
  const [select, setSelect] = useState("gst");
  const [typeFilter, setTypeFilter] = useState("All");
  const [nameFilter, setNameFilter] = useState("All");
  //const [kotNumber,setKotNumber]=useState('');
  const [uniqueNames, setUniqueNames] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm1, setSearchTerm1] = useState("");
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [focusedIndex1, setFocusedIndex1] = useState(-1);
  const [note, setNote] = useState("");
  const [bill, setBill] = useState([]);
  const [waiterList, setWaiterList] = useState([]);
  const [kotBill, setKotBill] = useState([]);
  const [activeTab, setActiveTab] = useState("food");

  const [printData, setPrintData] = useState([]);
  const [quickBill, setQuickBill] = useState({
    foodItem: [],
    phoneNo: "",
    name: "",
    foodRate: 0,
    tableNo: "",
    cgst: 0,
    sgst: 0,
    totalBilling: 0,
    discount: null,
    discountPercentage: null,
    cash: null,
    card: null,
    isComplementary: false,
    complementaryBy: "",

    mode: "",
    online: null,
    billNo: "",
    transactionId: "",

    cardNo: "",
    bankName: "",
    date: "",
    time: "",
    gst: false,
    remark: "",
    due: 0,
    foodDiscount: null,
    wineDiscount: null,
    happyHour: false,
    happyHourDiscountPercentage: null,
    tax: 0,
  });
  const handleChangeNote = (index, e) => {
    setFoodNote(e.target.value);
  };
  //console.log()
  const handleQuickDataChange = (e) => {
    const { name, value } = e.target;
    setQuickBill({
      ...quickBill,
      [name]: value,
    });
  };
  // Initialize useHistory hook
  // const [billItems, setBillItems] = useState([]);
  const [kot, setKot] = useState("Kot");
  const [selection, setSelection] = useState("Food");

  const [kotData, setKotData] = useState({
    foodItem: [],
    wineItem: [],
    tableNo: tableNo ? tableNo : "",
    kotNo: "",
    foodRate: 0,
    nc: false,
    serverName: "",
    totalBilling: 0,
  });
  //console.log(kotData.nc,'kotData.nc')

  // const handlequantity=(e)=>{
  //   setQuantity(e.target.value)
  // }

  const [wineData, setWineData] = useState([]);
  const [formData, setFormData] = useState({
    foodItem: [],

    tableNo: tableNo ? tableNo : "",
    foodRate: 0,
    sgst: 0,
    cgst: 0,

    totalBilling: 0,
  });
  //console.log(billItems,'bill')
  const currentTable = useMemo(() => {
    if (!Array.isArray(billItems)) {
      return { items: [] };
    }

    const foundTable = billItems.find(
      (item) => String(item.tableNo) === String(tableNo),
    );

    return foundTable || { items: [] };
  }, [billItems, tableNo]);

useEffect(() => {
 



  // Refresh every 1 second
  const interval = setInterval(() => {
    fetchTableBillItems(customerId, tableNo);
  }, 1000);

  return () => clearInterval(interval);
}, [ tableNo, fetchTableBillItems]);



  //console.log(foodItems,'foodItems')
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleCheckboxChange1 = (e) => {
    onOpen();

    const { name, checked } = e.target;
    setKotData((prevFormData) => ({
      ...prevFormData,
      [name]: checked,
    }));
  };
  //  const handleCheckboxChangeHsn = (e) => {

  //   const { name, checked } = e.target;
  //   setHsnView((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: checked,
  //   }));
  // }

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setQuickBill((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
    }));
  };
  const handleKotDataChange = (e) => {
    const { name, value } = e.target;

    setKotData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // ✅ Update the context and backend when serverName is changed
    if (name === "serverName") {
      updateServerName(customerId, value, tableNo);
    }
  };
  const listRef = useRef(null); // Ref for the <OrderedList>
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown" && filteredData.length > 0) {
      e.preventDefault();
      const nextIndex = (focusedIndex + 1) % filteredData.length;
      setFocusedIndex(nextIndex);
      scrollIntoView(nextIndex);
    } else if (e.key === "ArrowUp" && filteredData.length > 0) {
      e.preventDefault();
      const nextIndex = (focusedIndex - 1) % filteredData.length;
      setFocusedIndex(nextIndex);
      scrollIntoView(nextIndex);
    } else if (e.key === "Enter" && focusedIndex !== -1) {
      e.preventDefault();
      handleAddToBill(filteredData[focusedIndex]);
    }
  };
  const resetSearchResults = () => {
    setSearchTerm("");
    setFocusedIndex(-1);
    setFilteredData(data); // restore full list
  };

  const listRef1 = useRef(null);
  const handleKeyDown1 = (e) => {
    const currentList = filteredData;

    if (e.key === "ArrowDown" && currentList.length > 0) {
      e.preventDefault();
      const nextIndex = (focusedIndex + 1) % currentList.length;
      setFocusedIndex(nextIndex);
      scrollIntoView(nextIndex);
    } else if (e.key === "ArrowUp" && currentList.length > 0) {
      e.preventDefault();
      const nextIndex =
        (focusedIndex - 1 + currentList.length) % currentList.length;
      setFocusedIndex(nextIndex);
      scrollIntoView(nextIndex);
    } else if (e.key === "Enter" && focusedIndex !== -1) {
      e.preventDefault();

      const selectedItem = currentList[focusedIndex];

      // 👉 Always add directly to bill on Enter
      handleAddToBill(selectedItem);

      resetSearchResults();
    }
  };

  const scrollIntoView = (index) => {
    if (listRef.current && listRef.current.childNodes[index]) {
      listRef.current.childNodes[index].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  const scrollIntoView1 = (index) => {
    if (listRef1.current && listRef1.current.childNodes[index]) {
      listRef1.current.childNodes[index].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  const handleSelect = (e) => {
    setSelect(e.target.value);

    setQuickBill({
      ...quickBill,
      gst: select === "gst" ? quickBill.gst : !quickBill.gst,
    });
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const componentRef1 = useRef();
  const handlePrint1 = useReactToPrint({
    content: () => componentRef1.current,
  });
  const componentRef2 = useRef();
  const handlePrint2 = useReactToPrint({
    content: () => componentRef2.current,
  });

  const customerId = localStorage.getItem("customerId");
  const cacheImageUrl = (key, url) => {
    localStorage.setItem(`imageUrl-${key}`, url);
  };

  const getCachedImageUrl = (key) => {
    return localStorage.getItem(`imageUrl-${key}`);
  };
  //const items=fetchTableBillItems(customerId,tableNo)
  //console.log(billItems)
  // console.log(customerId);
  const kotFetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getKotBillData/${customerId}`,
      );
      setKotBill(response.data);
    } catch (error) {}
  };
  //  const fetchTableData = async (tableNo) => {
  //    try {
  //      const response = await axios.get(`https://api.rasoi.launchlysoftware.in/api/getItems/${customerId}/${tableNo}`);
  //      setOrder(prev => ({
  //        ...prev,
  //        [tableNo]: response.data.items,
  //      }));
  //      setFields(prev => ({
  //        ...prev,
  //        [tableNo]: response.data,
  //      }));
  //    } catch (error) {
  //      // Handle error
  //    }
  //  };
  const generateKotBillNo = () => {
    let latestKotNo = null;

    for (let i = kotBill?.length - 1; i >= 0; i--) {
      if (kotBill[i].kotNo) {
        latestKotNo = kotBill[i].kotNo;
        break;
      }
    }
    const year = new Date().getFullYear(); // Get the current year
    const prefix = `${tableNo}-`;

    // If there is a latest bill number, extract the numeric part and increment it
    if (latestKotNo) {
      const latest = latestKotNo.split("-");
      const latestNumber = latest[latest.length - 1];
      console.log(latestNumber, latestKotNo, "latestNumber"); // Get the last part of the billNo
      const newNumber = parseInt(latestNumber) + 1;
      console.log(newNumber, "newNumber");
      if (kotData.nc === true) {
        return `${prefix}-NC-${newNumber}`;
      } else {
        return `${prefix}${newNumber}`;
      } // Increment and return the new bill number
    }

    // If no previous bill number, start from '001'
    return `${prefix}1`;
  };
  const generatekotNo = generateKotBillNo();
  //console.log(generatekotNo,'generatekotNo')
  const wineFetchData = async () => {
    const response = await axios.get(
      `https://api.rasoi.launchlysoftware.in/api/getWineData/${customerId}`,
    );
    const wines = response.data.wine;
    //const {isOpen, onOpen, onClose} = useDisclosure({});
    const updatedWines = await Promise.all(
      wines.map(async (room) => {
        if (room.itemPhoto) {
          // Check if the image is already cached

          try {
            // const imageResponse = await axios.get(`https://api.rasoi.launchlysoftware.in/get-image/${room.itemPhoto}`, {
            //   responseType: 'blob', // Assuming the image is returned as a blob
            // });

            // Create a blob URL for the image
            //cachedUrl = URL.createObjectURL(imageResponse.data);

            // Cache the URL for future use
            // room.imageUrl=URL.createObjectURL(imageResponse.data)
            room.imageUrl = null;
          } catch (error) {
            console.error(
              `Error fetching image for room: ${room.image}`,
              error,
            );
            room.imageUrl = null; // Fallback in case of error
          }

          // Assign the cached or fetched URL
        } else {
          room.imageUrl = null; // Handle cases where image is missing
        }
        return room;
      }),
    );

    setWineData(updatedWines);
    setWineFilterData(updatedWines);
    setUniqueNames([
      "All",
      ...new Set(updatedWines.map((item) => item.category)),
    ]);
  };
  //console.log(wineData,'wine')
  const BillData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getQuickBillData/${customerId}`,
      );
      setBill(response.data.quickBill);
    } catch (error) {
      toast.error(error.message);
    }
  };

  //console.log(printData,'printData')

  //console.log(quickBill,'quickBill')

  // const fetchData = async () => {
  //   try {
  //     // Fetch the room data
  //     const response = await axios.get(`https://api.rasoi.launchlysoftware.in/api/getFoodData/${customerId}`);
  //     const rooms = response.data.food;

  //     // Process the rooms and cache the images
  //     const updatedRooms = await Promise.all(
  //       rooms.map(async (room) => {
  //         if (room.image) {
  //           const cachedImage = localStorage.getItem(room.image); // Check if the image is cached

  //           if (cachedImage) {
  //             // Use the cached image
  //             room.imageUrl = cachedImage;
  //           } else {
  //             try {
  //               // Fetch the image as a blob
  //               const imageResponse = await axios.get(`https://api.rasoi.launchlysoftware.in/get-image/${room.image}`, {
  //                 responseType: 'blob',
  //               });

  //               // Convert the blob to a Base64 string
  //               const reader = new FileReader();
  //               reader.readAsDataURL(imageResponse.data);

  //               const base64Promise = new Promise((resolve) => {
  //                 reader.onloadend = () => resolve(reader.result);
  //               });

  //               const base64Image = await base64Promise;

  //               // Store the Base64 string in localStorage
  //               localStorage.setItem(room.image, base64Image);

  //               // Assign the Base64 string as the image URL
  //               room.imageUrl = base64Image;
  //             } catch (error) {
  //               console.error(`Error fetching image for room: ${room.image}`, error);
  //               room.imageUrl = null; // Fallback in case of error
  //             }
  //           }
  //         } else {
  //           room.imageUrl = null; // Handle cases where image is missing
  //         }
  //         return room;
  //       })
  //     );

  //     // Combine and set the data
  //     const combinedData = [...updatedRooms];
  //     setData(combinedData);
  //     setFilteredData(combinedData);
  //     setUniqueNames(['All', ...new Set(combinedData.map((item) => item.category))]);
  //   } catch (error) {
  //     console.error("Error fetching room data:", error);
  //   }
  // };
  const fetchData = async () => {
    try {
      const foodRes = await axios
        .get(
          `https://api.rasoi.launchlysoftware.in/api/getFoodData/${customerId}`,
        )
        .catch(() => ({ data: { food: [] } }));

      const wineRes = await axios
        .get(
          `https://api.rasoi.launchlysoftware.in/api/getWineData/${customerId}`,
        )
        .catch(() => ({ data: { wine: [] } }));

      const foodData = foodRes.data.food || [];
      const wineData = wineRes.data.wine || [];

      const combinedData = [...foodData, ...wineData];

      setData(combinedData);
      setFilteredData(combinedData);

      setUniqueNames([
        "All",
        ...new Set(combinedData.map((item) => item.category)),
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //console.log(data)

  const fetchData3 = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getPrintData/${customerId}`,
      );
      const rooms = response.data;

      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(
              `https://api.rasoi.launchlysoftware.in/get-image/${room.image}`,
              {
                responseType: "blob", // Assuming image is returned as a blob
              },
            );

            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        }),
      );

      // console.log(updatedRooms, 'updatedRooms');
      setPrintData(updatedRooms);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //console.log(data,'data')
  const handleTypeFilterChange = (filter) => {
    setTypeFilter(filter);
    filterData(filter, nameFilter);
  };

  const handleNameFilterChange = (filter) => {
    setNameFilter(filter);
    filterData(typeFilter, filter);
  };
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData1(event.target.value);
  };
  const handleSearchChange1 = (event) => {
    setSearchTerm1(event.target.value);
    filterData2(event.target.value);
  };

  const filterData = (type, name) => {
    let filtered = selection === "Food" ? data : wineData;
    if (type !== "All") {
      filtered = filtered.filter((item) => item.type === type);
    }
    if (name !== "All") {
      filtered = filtered.filter((item) => item.category === name);
    }
    if (selection === "Food") {
      setFilteredData(filtered);
    } else {
      setWineFilterData(filtered);
    }
  };
  // console.log(filterData,'filterData')
  const filterData1 = (term) => {
    if (!term) {
      const combinedData = [...data, ...wineData];
      setFilteredData(data); // Reset filteredData to all data if search term is empty
    } else {
      const lowerCaseTerm = term.toLowerCase();
      const filtered = data.filter(
        (item) =>
          item.name.toLowerCase().includes(lowerCaseTerm) ||
          item.code.includes(term),
      );
      setFilteredData(filtered);
    }
  };
  const filterData2 = (term) => {
    if (!term) {
      const combinedData = [...data, ...wineData];
      setWineFilterData(wineData); // Reset filteredData to all data if search term is empty
    } else {
      const lowerCaseTerm = term.toLowerCase();
      const filtered = wineData.filter(
        (item) =>
          item.name.toLowerCase().includes(lowerCaseTerm) ||
          item.code.includes(term),
      );
      setWineFilterData(filtered);
    }
  };
  const dispatch = useDispatch();
  //console.log(printData[0]?.gst,"printData1234")
  useEffect(() => {
    // console.log("printData[0]?.gst:", printData[0]?.gst);
    if (printData[0]) {
      setSelect(printData[0]?.gst ? "gst" : "non-gst");
      setHsnView(printData[0].gst && printData[0]?.hsnView);
    }
    BillData();
  }, [customerId, printData]);
  // Load billItems from localStorage on component mount
  useEffect(() => {
    const loadData = async () => {
      if (!customerId || !tableNo) return;

      setLoading(true);
      try {
        await Promise.all([
          wineFetchData(),
          fetchData(),
          fetchKotNo(customerId, tableNo),
          kotFetchData(),
          fetchTableBillItems(customerId, tableNo),
          fetchData3(),
        ]);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [customerId, tableNo]);
  useEffect(() => {
    dispatch(fetchHappyHour(customerId));
  }, [customerId, tableNo, dispatch]);
  useEffect(() => {
    if (customerId && tableNo) {
      getNc(customerId, tableNo); // Fetch NC details when component mounts
    }
  }, [customerId, tableNo, getNc]);

  //console.log(typeof(latestBillNo),'latestBillNo')
  const resName = printData.map((item) => {
    return item.name;
  });
  //console.log(resName,'resName')
  const restaurentName = resName.toString();
  //console.log(typeof(restaurentName),restaurentName,'restaurentName')
  let latestBillNo;
  //let billNew=latestBillNo.split('-')

  for (let i = bill.length - 1; i >= 0; i--) {
    if (bill[i].billNo) {
      latestBillNo = bill[i].billNo;
      break;
    }
    continue;
  }
  console.log(latestBillNo, "latestBillNo");
  let latestNumber = 0;
  let latestPrefix = "";

  for (let i = bill.length - 1; i >= 0; i--) {
    const currentBill = bill[i].billNo;
    if (!currentBill) continue;

    // For GST bills
    if (select === "gst" && currentBill.includes("-G-")) {
      latestPrefix = currentBill.split("-").slice(0, -1).join("-");
      latestNumber = parseInt(currentBill.split("-").pop());
      break;
    }

    // For Non-GST bills
    if (select === "non-gst" && currentBill.includes("-NG-")) {
      latestPrefix = currentBill.split("-").slice(0, -1).join("-");
      latestNumber = parseInt(currentBill.split("-").pop());
      break;
    }

    // If neither GST nor Non-GST, fallback to any bill with number
    if (
      !currentBill.includes("-G-") &&
      !currentBill.includes("-NG-") &&
      latestNumber === 0
    ) {
      latestPrefix = currentBill.split("-").slice(0, -1).join("-");
      latestNumber = parseInt(currentBill.split("-").pop());
    }
  }

  const generateBillNo = (latestBillNo, resName) => {
    const year = new Date().getFullYear(); // Get the current year

    // Extract initials from the restaurant name
    const getInitials = (name) => {
      const ignoreWords = ["and", "of", "the", "in", "&", "at"];

      return name
        .split(" ") // Split the name by spaces
        .filter((word) => !ignoreWords.includes(word.toLowerCase())) // Exclude ignored words
        .slice(0, 2) // Take only the first two valid words
        .map((word) => word[0]) // Take the first letter of each word and convert to uppercase
        .join(""); // Join the initials to form the prefix
    };

    const prefix =
      select === "gst"
        ? `${getInitials(resName)}-${year}-${tableNo}-G-`
        : `${getInitials(resName)}-${year}-${tableNo}-NG-`;
    // Create the prefix

    // If there is a latest bill number, extract the numeric part and increment it
    if (latestBillNo) {
      const parts = latestBillNo.split("-");
      const lastPart = parts[parts.length - 1]; // Get the last part of the split string
      const lastNumber = parseInt(lastPart, 10); // Get the last part of the billNo
      const newNumber = latestNumber + 1;
      return `${prefix}${newNumber}`; // Increment and return the new bill number
    }
    // console.log(prefix,'prefix')

    // If no previous bill number, start from '1'
    return `${prefix}1`;
  };

  // console.log(latestBillNo,'latestBillNo')

  // Save billItems to localStorage whenever it changes

  // Save billItems to localStorage whenever it changes

  const handleAddToBill = (item) => {
    const priceAdd = printData[0]?.priceAdd;
    const prcieAddDiscount = printData[0]?.priceAddPercentage;
    // Check if the item already exists in the bill
    // console.log(priceAdd,prcieAddDiscount,'price')
    addToBill(
      customerId,
      item,
      isAc,
      isHalf,
      tableNo,
      isBottle,
      isHappyHour,
      happyDiscount,
      priceAdd,
      prcieAddDiscount,
    );
  };
  // const changeNote = (index, note) => {
  //   // setNote(e.target.value)
  //   updateNote(customerId, tableNo, index, note)
  // }
  const changeNote = (index, note) => {
    // Update local state immediately for smooth typing
    setBillItems((prevBillItems) => {
      const tableBillIndex = prevBillItems.findIndex(
        (bill) => bill.tableNo === tableNo,
      );
      if (tableBillIndex === -1) return prevBillItems;

      const updatedItems = [...prevBillItems[tableBillIndex].items];
      updatedItems[index] = { ...updatedItems[index], note };

      const newBillItems = [...prevBillItems];
      newBillItems[tableBillIndex] = {
        ...prevBillItems[tableBillIndex],
        items: updatedItems,
      };

      return newBillItems;
    });

    // Now update backend asynchronously
    updateNote(customerId, tableNo, index, note);
  };

  const handleQuantityChange = (index, quantity) => {
    // Update state immediately

    // Call the API to update the backend
    updateQuantity(customerId, tableNo, index, quantity);
  };
  const handlePriceChange = (index, rateType) => {
    setBillItems((prevBillItems) => {
      const tableBillIndex = prevBillItems.findIndex(
        (bill) => bill.tableNo === tableNo,
      );
      if (tableBillIndex === -1) return prevBillItems;

      const updatedItems = [...prevBillItems[tableBillIndex].items];
      const existingItem = updatedItems[index];
      const quantity = existingItem.quantity;
      const price = Number(rateType) * quantity; // Example logic — adapt if needed

      updatedItems[index] = {
        ...existingItem,
        rateType,
        price: !isNaN(price) ? price : existingItem.price,
      };

      const newBillItems = [...prevBillItems];
      newBillItems[tableBillIndex] = {
        ...prevBillItems[tableBillIndex],
        items: updatedItems,
      };

      return newBillItems;
    });

    // Call the API to update backend
    updatePrice(customerId, tableNo, index, rateType);
  };

  const handleDiscount = (index, discount) => {
    // Update state immediately

    // Call the API to update the backend
    updateDiscount(customerId, tableNo, index, discount);
  };

  useEffect(() => {
    if (kotNumber.includes("NC")) {
      setQuickBill((prev) => ({
        ...prev,
        isComplementary: true,
        cashDiscount: 0,
        totalBilling: 0,
      }));
    }
  }, [kotNumber, tableNo]);
  useEffect(() => {
    if (ncData && ncData.name) {
      setQuickBill((prev) => ({
        ...prev,
        name: ncData.name,
        phoneNo: ncData.phoneNo,
      }));
    }
  }, [ncData, tableNo, customerId]); // Include ncData in dependencies

  console.log(ncData.name, "ncname");

  const handleDeleteItem = (index) => {
    deleteItem(customerId, tableNo, index);
  };
  const handleClearBill = (tableNo) => {
    clearBill(customerId, tableNo);
  };
  const handleClearBills = async (tableNo) => {
    if (!kotNumber) {
      alert("No KOT selected to delete!");
      return;
    }
    const confirmDelete = window.confirm(
      "Are you sure you want to clear this KOT?",
    );
    if (!confirmDelete) return;
    try {
      const response = await axios.delete(
        `https://api.rasoi.launchlysoftware.in/api/deleteKot/${customerId}/${kotNumber}`,
      );

      console.log("✅ Deleted KOT:", response.data);

      if (billItems && billItems.length > 0) {
        const tableItems = billItems.find((b) => b.tableNo === tableNo);
        if (tableItems?.items) {
          for (let i = tableItems.items.length - 1; i >= 0; i--) {
            await deleteItem(customerId, tableNo, i);
          }
        }
      }
      const clearBill = (customerId, tableNo) => {
        setBillItems((prev) => prev.filter((item) => item.tableNo !== tableNo));
        // optionally also call API to clear items if needed
      };
      await clearBill(customerId, tableNo);
      // ✅ Clear kotNumber + serverName
      await clearKotNo(customerId, tableNo);
      await clearServerName(customerId, tableNo);
    } catch (error) {
      console.error("❌ Error deleting KOT:", error);
      alert("Failed to delete KOT");
    }
  };

  const totalAmount = currentTable.items.reduce(
    (acc, item) => acc + item.price,
    0,
  );
  const taxableFood = currentTable.items.filter(
    (item) => "description" in item,
  );
  const wineItems = currentTable.items.filter((item) => "stockMl" in item);
  let wineAmount = wineItems?.reduce((acc, item) => acc + item.price, 0);
  let wineAmount1 = wineItems?.reduce((acc, item) => acc + item.price, 0);
  wineAmount =
    wineAmount -
    (quickBill.wineDiscount
      ? (quickBill.wineDiscount * wineAmount) / 100
      : isHappyHour && happyDiscount > 0
      ? (happyDiscount * wineAmount) / 100
      : 0);

  let taxableAmount = taxableFood?.reduce((acc, item) => acc + item.price, 0);
  let taxableAmount1 = taxableFood?.reduce((acc, item) => acc + item.price, 0);
  taxableAmount =
    taxableAmount -
    (quickBill.foodDiscount
      ? (quickBill.foodDiscount * taxableAmount) / 100
      : isHappyHour && happyDiscount > 0
      ? (happyDiscount * taxableAmount) / 100
      : 0);
  //console.log(wineAmount,taxableAmount,'wine')
  //console.log(taxableAmount,'tax')
  let totalSum;

  let arr1 = currentTable.items.map((item) => {
    return {
      name: item.name,
      quantity: item.quantity,
      price: item.price,
      unit: item.unit,
      note: item.note,
      discountItem: item.discountItem,
    };
  });
  //console.log(Object.entires(arr1),'arr1')
  let arr3 = currentTable.items
    .filter((item) => "description" in item)
    .map((item) => {
      return {
        name: item.name,
        quantity: item.quantity,
        price: item.price,
        unit: item.unit,
        note: item.note,
        discountItem: item.discountItem,
        hsnNo: item.hsnNo,
        gstPercentage: item.gstPercentage,
        cgst: item.cgst,
        sgst: item.sgst,
      };
    });

  //console.log(arr3,'arr3')
  // let arr3=currentTable ?.items.filter(item=> item.description !== '').map((item=>{
  //   return {
  //     name: item.name,
  //     quantity: item.quantity,
  //     price: item.price,
  //     unit:item.unit

  //   }
  // }))
  console.log(currentTable, "foodItems");

  let arr2 = currentTable?.items
    .filter((item) => "stockMl" in item)
    .map((item) => {
      return {
        name: item.name,
        quantity: item.quantity,
        price: item.price,
        unit: item.unit,
        discountItem: item.discountItem,
      };
    });
  // let arr2=currentTable ?.items.filter(item=> item.stockMl !== 0).map((item=>{
  //   return {
  //     name: item.name,
  //     quantity: item.quantity,
  //     price: item.price,
  //     unit:item.unit

  //   }
  // }))
  //console.log(arr2,'arr2')

  console.log(hsnView, "hsnView");

  const handleKotChange = (e) => {
    setKot(e.target.value);
  };
  //setFoodItemsData(arr1)
  let rcgst;
  let rsgst;
  if (select == "gst") {
    // rcgst=currentTable ?.items.filter(item=> 'description' in item).reduce((a,b)=>{return a+(b.gstPercentage*b.quantity)},0);

    // rsgst=currentTable ?.items.filter(item=> 'description' in item).reduce((a,b)=>{return a+(b.gstPercentage*b.quantity)},0);;
    rcgst = currentTable?.items
      .filter((a) => "description" in a)
      .reduce((a, b) => {
        const gst =
          b.gstPercentage != null
            ? b.quantity * b.gstPercentage
            : b.quantity * b.price * 0.025;
        return a + gst;
      }, 0);

    rsgst = currentTable?.items
      .filter((a) => "description" in a)
      .reduce((a, b) => {
        const gst =
          b.gstPercentage != null
            ? b.quantity * b.gstPercentage
            : b.quantity * b.price * 0.025;
        return a + gst;
      }, 0);

    totalSum = (wineAmount + taxableAmount + rcgst + rsgst).toFixed(2);
  } else {
    rcgst = 0;

    rsgst = 0;
    totalSum = wineAmount + taxableAmount + rcgst + rsgst;
  }
  console.log(
    currentTable?.items.filter((a) => "description" in a),
    "rcgst",
  );
  //const kotPrint =UseKotPrint(arr1, tableNo, totalAmount)

  const kotPrint = UseKotPrint(
    arr1,
    tableNo,
    totalAmount,
    generatekotNo,
    kotData.nc,
    kotData.serverName,
  );
  const kotUpdate = UpdateKotPrint(arr1, tableNo, totalAmount, "Kitchen");
  const handleSelectionChange = (type) => {
    setSelection(type);
    if (selection === "Food") {
      setUniqueNames([
        "All",
        ...new Set(wineData.map((item) => item.category)),
      ]);
    } else {
      setUniqueNames([
        "All",
        ...new Set(filteredData.map((item) => item.category)),
      ]);
    }
  };

  // Determine which data to display
  const dataToDisplay = selection === "Food" ? filteredData : wineFilterData;

  const handleSaveAndPrint = async () => {
    // Prepare data to send to backend

    // console.log(billItems)

    setFormData({
      foodItem: arr1,

      tableNo: kotData.tableNo,
      foodRate: totalAmount,
      cgst: rcgst,
      sgst: rsgst,

      totalBilling: quickBill.isComplementary ? 0 : Math.round(totalSum),
    });
    // Update submitted data here
    // setFormData(updatedData)

    //  console.log(formData)
  };
  let cashDiscount = useMemo(() => {
    if (!quickBill) return 0;

    if (quickBill.isComplementary) return 0;

    const fixedDiscount = quickBill.discount || 0;
    const percentageDiscount = quickBill.discountPercentage
      ? totalSum * (quickBill.discountPercentage / 100)
      : 0;
    const happyDiscountAmount =
      printData[0]?.splitBill === false && isHappyHour && happyDiscount > 0
        ? totalSum * (happyDiscount / 100)
        : 0;

    return totalSum - fixedDiscount - percentageDiscount - happyDiscountAmount;
  }, [quickBill, totalSum, quickBill.discountPercentage]);
  useEffect(() => {
    const rounded = Math.round(cashDiscount);
    const difference = cashDiscount - rounded;
    setRoundOff(difference > 0 ? difference : difference * -1);
  }, [cashDiscount]);

  console.log(roundOff, "roundOff");
  const onLineFoucus = (e) => {
    setQuickBill({
      ...quickBill,
      online: (
        Math.round(cashDiscount) - (quickBill.cash ? quickBill.cash : 0)
      ).toFixed(2),
    });
  };

  const cashFoucus = (e) => {
    setQuickBill({
      ...quickBill,
      cash: (
        Math.round(cashDiscount) - (quickBill.online ? quickBill.online : 0)
      ).toFixed(2),
    });
  };
  console.log(cashDiscount, "cashDiscount1234");
  const randomBillNumber = `${tableNo}-${Math.floor(Math.random() * 1000000)}`;
  let date;
  let time;
  function getFormattedCurrentDate() {
    const now = new Date(); // Get the current date and time

    // Format the date as "DD-MM-YYYY"
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0"); // getMonth() is 0-based, so +1
    const year = now.getFullYear();

    // Format the time as "HH:MM AM/PM"
    let hours = now.getHours();
    let minutes = String(now.getMinutes()).padStart(2, "0"); // Add leading zero to minutes if needed
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 24-hour time to 12-hour time, adjusting midnight to 12
    const date = `${day}-${month}-${year} `;
    const time = `${hours}:${minutes}${period.toLowerCase()}`;

    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}${period.toLowerCase()}`;

    return [formattedDate, date, time];
  }

  // console.log(getFormattedCurrentDate()); // Output: "21-10-2024 12am"

  const newBillNo = generateBillNo(latestBillNo, restaurentName);
  // const dueFoucus=(e)=>{
  //   setQuickBill({
  //     ...quickBill,
  //     due:(cashDiscount-(quickBill.cash+quickBill.online+quickBill.card))
  //   })
  // }

  useEffect(() => {
    if (quickBill.cash || quickBill.online || quickBill.card) {
      setQuickBill({
        ...quickBill,
        due: (
          Math.round(cashDiscount) -
          (parseFloat(quickBill.cash || 0) +
            parseFloat(quickBill.online || 0) +
            parseFloat(quickBill.card || 0))
        ).toFixed(2),
      });
    } else {
      setQuickBill({
        ...quickBill,
        due: null,
      });
    }
  }, [quickBill.cash, quickBill.online, quickBill.card, cashDiscount]);

  useEffect(() => {
    setQuickBill({
      ...quickBill,
      cash: (
        Math.round(cashDiscount) -
        (parseFloat(quickBill.online || 0) + parseFloat(quickBill.card || 0))
      ).toFixed(2),
    });
  }, [quickBill.online, quickBill.card, cashDiscount]);

  // useEffect(()=>{
  //   setQuickBill({
  //     ...quickBill,
  //     online:(cashDiscount-(parseInt(quickBill.cash?quickBill.cash:0))).toFixed(2),

  //   })},[quickBill.cash])

  useEffect(() => {
    if (quickBill.isComplementary) {
      setQuickBill({
        ...quickBill,
        totalBilling: 0,
        cash: 0,
        card: 0,
        online: 0,
        due: 0,
      });
      cashDiscount = 0;
    }
    // console.log(quickBill.isComplementary,'quickBill.isComplementary')
  }, [quickBill.isComplementary]);

  //console.log(quickBill.cash,quickBill.online,quickBill.card,quickBill.due,'quickBill')
  const newDate = getFormattedCurrentDate();
  //console.log(newBillNo,'newBillNo')
  const quickSave = (e) => {
    const billData = {
      foodItem: arr3,
      tableNo: tableNo,
      wineItem: arr2,
      name: quickBill.name,
      phoneNo: quickBill.phoneNo,
      foodRate: totalAmount,
      cgst: rcgst,
      sgst: rsgst,
      discount: quickBill.discount,
      discountPercentage: quickBill.discountPercentage,
      cash: quickBill.cash,
      card: quickBill.card,
      online: quickBill.online,
      totalBilling: quickBill.isComplementary ? 0 : Math.round(totalSum),
      billNo: newBillNo,
      mode: quickBill.mode,
      transactionId: quickBill.transactionId,
      cardNo: quickBill.cardNo,
      bankName: quickBill.bankName,
      date: newDate[1],
      time: newDate[2],
      server: serverName,
      gst: quickBill.gst,
      remark: quickBill.remark,
      due: quickBill.due,
      isComplementary: quickBill.isComplementary,
      complementaryBy: quickBill.complementaryBy,
      wineDiscount: quickBill.wineDiscount,
      foodDiscount: quickBill.foodDiscount,
      happyHour: isHappyHour ? true : false,
      happyHourDiscountPercentage: isHappyHour ? happyDiscount : 0,
      tax: rcgst + rsgst,
    };

    setQuickBill(billData);

    // ✅ Load existing records from localStorage
    let storedBills = JSON.parse(localStorage.getItem("billItems")) || [];

    // ✅ Check if this table already exists
    const existingIndex = storedBills.findIndex((b) => b.tableNo === tableNo);

    if (existingIndex >= 0) {
      // Update existing entry
      storedBills[existingIndex].billNo = newBillNo || "";
      storedBills[existingIndex].discountPercentage =
        quickBill.discountPercentage || "";
    } else {
      // Insert new entry
      storedBills.push({
        tableNo,
        billNo: newBillNo || "",
        discountPercentage: quickBill.discountPercentage || "",
      });
    }

    // ✅ Save back to localStorage
    localStorage.setItem("billItems", JSON.stringify(storedBills));

    console.log("💾 Updated billItems:", storedBills);
  };

  // console.log(kotNumber,'kot1')
  // console.log(Object.keys(quickBill),Object.values(quickBill),'quickBill')
  // console.log(quickBill.isComplementary,'quickBill.isComplementary')
  const print = () => {
    handlePrint();
  };
  const print1 = () => {
    handlePrint1();
  };
  const print2 = () => {
    handlePrint2();
  };
  //console.log(quickBill,'quickBill')

  // console.log(formData,'formData')
  const save = async (e) => {
    e.preventDefault();
    const updateFormData = {
      ...formData,

      foodItem: arr3,
      tableNo: tableNo,
      wineItem: arr2,
      name: quickBill.name,
      phoneNo: quickBill.phoneNo,
      foodRate: totalAmount,
      cgst: rcgst,
      sgst: rsgst,
      discount: quickBill.discount,
      discountPercentage: quickBill.discountPercentage,
      cash: quickBill.cash,
      card: quickBill.card, 
      online: quickBill.online,
      totalBilling: quickBill.isComplementary ? 0 : Math.round(totalSum),
      billNo: newBillNo,
      mode: quickBill.mode,
      transactionId: quickBill.transactionId,
      cardNo: quickBill.cardNo,
      bankName: quickBill.bankName,
      wineDiscount: quickBill.wineDiscount,
      foodDiscount: quickBill.foodDiscount,
      date: newDate[1],
      time: newDate[2],
      server: serverName,
      gst: quickBill.gst,
      happyHour: isHappyHour ? true : false,
      happyHourDiscountPercentage: isHappyHour ? happyDiscount.tofixe(2) : 0,
    };
    try {
      // Assuming you have a backend endpoint to send data to
      const response = await axios.post(
        "https://api.rasoi.launchlysoftware.in/api/foodBillRegister",
        {
          customerId: customerId,
          data: updateFormData,
        },
      );
      handlePrint();
      //   console.log('Bill saved:', response.data);
      toast.success(response.data.message);

      //  Optionally, you can reset the form data or perform any other actions upon successful save
      setFormData({
        foodItem: [],
        registration: "",
        foodRate: 0,
        tableNo: "",

        totalBilling: 0,
      });
      //setBillItems([]);
      handleClearBill(tableNo);
      // Add any further actions upon successful save here
    } catch (error) {
      //    console.error('Error saving bill:', error);
      toast.error("Error in food billing");
      // Handle error scenarios
    }
  };
  //console.log(quickBill.cash,quickBill.online,'quickBill')

  const qSave = async (e) => {
    e.preventDefault();

    const updatedQuickBill = {
      ...quickBill,
      foodItem: arr3,
      tableNo: tableNo,
      wineItem: arr2,
      name: quickBill.name,
      phoneNo: quickBill.phoneNo,
      foodRate: totalAmount,
      cgst: rcgst,
      sgst: rsgst,
      discount: quickBill.discount,
      discountPercentage: quickBill.discountPercentage,
      cash: quickBill.cash,
      card: quickBill.card,
      online: quickBill.online,
      totalBilling: quickBill.isComplementary ? 0 : Math.round(cashDiscount),
      billNo: newBillNo,
      mode: quickBill.mode,
      transactionId: quickBill.transactionId,
      cardNo: quickBill.cardNo,
      bankName: quickBill.bankName,
      date: newDate[1],
      time: newDate[2],
      server: serverName,
      gst: quickBill.gst,
      remark: quickBill.remark,
      due: quickBill.due,
      wineDiscount: quickBill.wineDiscount,
      foodDiscount: quickBill.foodDiscount,
      tax: rcgst + rsgst,
    };

    if (updatedQuickBill.cash == null && updatedQuickBill.online == null) {
      toast.error("Please enter payment details cash or online");
      return;
    }

    setQuickBill(updatedQuickBill);

    try {
      const response = await axios.post(
        "https://api.rasoi.launchlysoftware.in/api/quickBillRegister",
        {
          customerId: customerId,
          data: updatedQuickBill,
        },
      );

      toast.success(response.data.message);
      clearNc(customerId, tableNo);

      const savedPrints = JSON.parse(localStorage.getItem("kotPrints")) || [];
      const updatedPrints = savedPrints.filter(
        (item) => item.tableNo !== tableNo,
      );
      localStorage.setItem("kotPrints", JSON.stringify(updatedPrints));
      const storedBills = JSON.parse(localStorage.getItem("billItems")) || [];
      const updatedBills = storedBills.map((b) =>
        b.tableNo === tableNo ? { ...b, discountPercentage: null } : b,
      );
      localStorage.setItem("billItems", JSON.stringify(updatedBills));
      // ✅ Reset the state
      setQuickBill({
        arr1: [],
        foodItem: [],
        wineItem: [],
        name: "",
        phoneNo: "",
        foodRate: 0,
        totalBilling: 0,
        tableNo: "",
        discount: null,
        discountPercentage: null,
        cash: null,
        card: null,
        mode: "",
        online: null,
        billNo: "",
        transactionId: "",
        cardNo: "",
        bankName: "",
        date: "",
        time: "",
        serverName: "",
        gst: false,
        remark: "",
        due: null,
        wineDiscount: 0,
        foodDiscount: 0,
        tax: 0,
      });

      handleClearBill(tableNo);
      clearKotNo(customerId, tableNo);
      clearServerName(customerId, tableNo);
    } catch (error) {
      toast.error(error.message);
    }
  };

  //console.log(cashDiscount,'cashDiscount')
  //console.log(quickBill.cash,'cash')
  //console.log(quickBill.due,'due')

  let arr = Object.entries(formData);
  //console.log(filteredData,'filteredData')

  useEffect(() => {
    axios
      .get(`https://api.rasoi.launchlysoftware.in/api/waiterList/${customerId}`)
      .then((res) => {
        setWaiterList(res.data.waiterList);
      })
      .catch((err) => {
        console.error("Failed to fetch waiter list:", err);
      });
  }, []);
  console.log("waiter list", waiterList);

  const handleSwitchTable = () => {
    navigate("/table-status");
  };

  useEffect(() => {
    const selectedTableNos =
      JSON.parse(localStorage.getItem("selectedTableNo")) || [];

    const tableEntry = selectedTableNos.find(
      (entry) => entry.tableNo === tableNo,
    );

    if (tableEntry && tableEntry.discountPercentage != null) {
      setQuickBill((prev) => ({
        ...prev,
        discountPercentage: tableEntry.discountPercentage,
      }));
    } else {
      // fallback if nothing stored
      setQuickBill((prev) => ({
        ...prev,
        discountPercentage: "",
      }));
    }
  }, [tableNo]);

  useEffect(() => {
    // Load discount for this table from localStorage
    const storedBills = JSON.parse(localStorage.getItem("billItems")) || [];

    const found = storedBills.find((b) => b.tableNo === tableNo);

    if (found) {
      setQuickBill((prev) => ({
        ...prev,
        discountPercentage: found.discountPercentage || "",
        billNo: found.billNo || "",
      }));
    }
  }, [tableNo]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" h="100vh">
        <Text>Loading...</Text>
      </Box>
    );
  }

  const startVoiceRecognition = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      alert("Speech Recognition not supported in this browser");
      return;
    }

    const recognition = new SpeechRecognition();

    recognition.continuous = false;
    recognition.lang = "en-IN";
    recognition.interimResults = false;

    recognition.onstart = () => {
      setIsListening(true);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error", event.error);
      setIsListening(false);
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript.toLowerCase().trim();

      console.log("Voice Input:", transcript);

      // Search item by name OR code
      const foundItem = [...data, ...wineData].find((item) => {
        return (
          item.name.toLowerCase().includes(transcript) ||
          item.code.toString() === transcript.replace("code ", "")
        );
      });

      if (foundItem) {
        handleAddToBill(foundItem);

        toast.success(`${foundItem.name} added`);
      } else {
        toast.error("Item not found");
      }
    };

    recognitionRef.current = recognition;
    recognition.start();
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      bg="#f5f5f5"
      h={840}
      overflow="hidden"
    >
      {/* Top Search Bar */}
      <Box bg="white" p={3} boxShadow="sm">
        <Flex gap={3} align="center">
          <Button
            colorScheme={isListening ? "red" : "green"}
            onClick={startVoiceRecognition}
          >
            {isListening ? <FaMicrophoneSlash /> : <FaMicrophone />}
          </Button>

          <Input
            flex="1"
            type="text"
            bg="white"
            border="1px solid #E8E8E6"
            placeholder="Search Item"
            value={searchTerm}
            onChange={handleSearchChange}
            onKeyDown={handleKeyDown1}
            size="md"
          />

          <Input
            flex="1"
            type="text"
            bg="white"
            border="1px solid #E8E8E6"
            placeholder="Enter Code"
            value={searchTerm1}
            onChange={handleSearchChange1}
            onKeyDown={handleKeyDown1}
            size="md"
          />

          <Button colorScheme="red" size="md" px={8}>
            Dine In
          </Button>

          <Button colorScheme="gray" size="md" px={8}>
            Delivery
          </Button>

          <Button colorScheme="gray" size="md" px={8}>
            Pick Up
          </Button>
        </Flex>
      </Box>

      {/* Search Results Dropdown */}
      {selection === "Food" ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <NcPopup
            isOpen={isOpen}
            onClose={onClose}
            onOpen={onOpen}
            customerId={customerId}
            tableNo={tableNo}
          />
          {searchTerm !== "" && (
            <Box
              position="absolute"
              top="80px"
              left="50%"
              transform="translateX(-50%)"
              width="50%"
              bg="white"
              boxShadow="lg"
              borderRadius="md"
              maxH="300px"
              overflowY="auto"
              zIndex={1000}
            >
              <OrderedList
                display="flex"
                flexDirection="column"
                ref={listRef}
                tabIndex={-1}
                m={0}
                p={2}
              >
                {filteredData.map((item, index) => (
                  <ListItem
                    as="i"
                    bg={index === focusedIndex ? "#0F3D2E" : "transparent"}
                    color={index === focusedIndex ? "white" : "black"}
                    p={3}
                    mb={1}
                    borderRadius="6px"
                    key={item._id}
                    onClick={() => handleAddToBill(item)}
                    cursor="pointer"
                    _hover={{ bg: "gray.100" }}
                  >
                    {item.name}
                  </ListItem>
                ))}
              </OrderedList>
            </Box>
          )}
        </Box>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          {searchTerm1 !== "" && (
            <Box
              position="absolute"
              top="80px"
              left="50%"
              transform="translateX(-50%)"
              width="50%"
              bg="white"
              boxShadow="lg"
              borderRadius="md"
              maxH="300px"
              overflowY="auto"
              zIndex={1000}
            >
              <OrderedList
                display="flex"
                flexDirection="column"
                ref={listRef1}
                tabIndex={-1}
                m={0}
                p={2}
              >
                {wineFilterData.map((item, index) => (
                  <ListItem
                    as="i"
                    bg={index === focusedIndex1 ? "#0F3D2E" : "transparent"}
                    color={index === focusedIndex1 ? "white" : "black"}
                    p={3}
                    mb={1}
                    borderRadius="6px"
                    key={item._id}
                    onClick={() => handleAddToBill(item)}
                    cursor="pointer"
                    _hover={{ bg: "gray.100" }}
                  >
                    {item.name}
                  </ListItem>
                ))}
              </OrderedList>
            </Box>
          )}
        </Box>
      )}

      {/* Main Content Area */}
      <Flex flex="1" overflow="hidden">
        {/* Left Sidebar - Categories */}
        <Box w="160px" bg="#5A5A5A" p={0} overflowY="auto">
          <Select
            w="full"
            bg="#5A5A5A"
            color="white"
            borderRadius="0"
            border="none"
            borderBottom="1px solid #4A4A4A"
            value={typeFilter}
            onChange={(e) => handleTypeFilterChange(e.target.value)}
            _hover={{ bg: "#7A7A7A" }}
            fontWeight="normal"
            fontSize="medium"
            h="48px"
            cursor="pointer"
            sx={{
              option: {
                bg: "#4A4A4A",
                color: "white",
              },
            }}
          >
            <option value="All">All Items</option>
            <option value="Veg">🟢 Veg</option>
            <option value="Non-Veg">🔴 Non-Veg</option>
          </Select>
          <VStack spacing={0} align="stretch">
            {uniqueNames.map((name, index) => (
              <Button
                key={index}
                onClick={() => handleNameFilterChange(name)}
                bg={nameFilter === name ? "#7A7A7A" : "#5A5A5A"}
                color="white"
                borderRadius="0"
                py={6}
                fontSize="sm"
                fontWeight="normal"
                _hover={{ bg: "#7A7A7A" }}
                justifyContent="flex-start"
                px={4}
                borderBottom="1px solid #4A4A4A"
              >
                {name}
              </Button>
            ))}
          </VStack>
        </Box>
        {/* Center - Food Items */}
        <Box
          flex="1"
          display="flex"
          flexDirection="column"
          overflow="hidden"
          bg="#E8E8E6"
        >
          <Flex bg="white" p={2} gap={2} borderBottom="1px solid #ddd">
            <Button
              flex="1"
              onClick={() => handleSelectionChange("Food")}
              bg={selection === "Food" ? "#0F3D2E" : "white"}
              color={selection === "Food" ? "white" : "black"}
              border="1px solid #ddd"
              _hover={{ bg: selection === "Food" ? "#0F3D2E" : "gray.100" }}
            >
              Food
            </Button>
            <Button
              flex="1"
              onClick={() => handleSelectionChange("Wine")}
              bg={selection === "Wine" ? "#0F3D2E" : "white"}
              color={selection === "Wine" ? "white" : "black"}
              border="1px solid #ddd"
              _hover={{ bg: selection === "Wine" ? "#0F3D2E" : "gray.100" }}
            >
              Wine
            </Button>
          </Flex>
          <Box flex="1" overflowY="auto" p={3}>
            <HalfPlateModal
              isOpen={isFoodModalOpen}
              onClose={onCloseFoodModal}
              onOpen={onOpenFoodModal}
              isHappyHour={isHappyHour}
              happyDiscount={happyDiscount}
              isAc={isAc}
              tableNo={tableNo}
              data={foodData}
              priceAdd={printData[0]?.priceAdd ? printData[0].priceAdd : false}
              prcieAddDiscount={
                printData[0]?.priceAddPercentage
                  ? printData[0].priceAddPercentage
                  : null
              }
            />
            <FullBottleModal
              isOpen={isWineModalOpen}
              onClose={onCloseWineModal}
              onOpen={onOpenWineModal}
              isHappyHour={isHappyHour}
              happyDiscount={happyDiscount}
              isAc={isAc}
              tableNo={tableNo}
              data={foodData1}
              isBottle={isBottle}
              priceAdd={printData[0]?.priceAdd ? printData[0].priceAdd : false}
              prcieAddDiscount={
                printData[0]?.priceAddPercentage
                  ? printData[0].priceAddPercentage
                  : null
              }
            />
            <SimpleGrid columns={4} spacing={3}>
              {dataToDisplay.map((item, index) => (
                <Card
                  key={index}
                  boxShadow="sm"
                  borderRadius="md"
                  overflow="hidden"
                  cursor="pointer"
                  transition="all 0.2s"
                  _hover={{ boxShadow: "md" }}
                  position="relative"
                  bg="white"
                  border="1px solid #E0E0E0"
                >
                  <Box
                    position="relative"
                    h="80px"
                    borderLeft={
                      item.type === "Non-Veg"
                        ? "4px solid #E53E3E"
                        : "4px solid #48BB78"
                    }
                    onClick={() => handleAddToBill(item)}
                  >
                    <Box
                      p={2}
                      h="full"
                      display="flex"
                      flexDirection="column"
                      justifyContent="space-between"
                    >
                      <Text fontSize="sm" fontWeight="medium" noOfLines={2}>
                        {item.name}
                      </Text>
                      <Flex justify="space-between" align="center">
                        <Text fontSize="xs" color="gray.600">
                          Code: {item.code}
                        </Text>
                        <Text fontSize="sm" fontWeight="bold" color="green.600">
                          ₹{isAc ? item.acRate : item.nonAcRate}
                        </Text>
                      </Flex>
                    </Box>
                    {isHappyHour && (
                      <Box
                        position="absolute"
                        top="1"
                        right="1"
                        bg="yellow.400"
                        color="black"
                        fontSize="10px"
                        px="1"
                        py="0.5"
                        borderRadius="sm"
                        fontWeight="bold"
                      >
                        {happyDiscount}%
                      </Box>
                    )}
                    <Flex position="absolute" bottom="1" right="1" gap={1}>
                      {item.halfPlate && (
                        <Box
                          bg="gray.100"
                          p={1}
                          borderRadius="sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToggle(item._id);
                          }}
                        >
                          <RxHalf2 size="14px" />
                        </Box>
                      )}
                      {item.halfPlate && item.purchaseRate && (
                        <Box
                          bg="gray.100"
                          p={1}
                          borderRadius="sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToggle1(item._id);
                          }}
                        >
                          <FaWineBottle size="14px" />
                        </Box>
                      )}
                    </Flex>
                  </Box>
                </Card>
              ))}
            </SimpleGrid>
          </Box>
        </Box>

        {/* Right Sidebar - Order Details */}
        <Box w="450px" display="flex" flexDirection="column" overflow="hidden">
          <Box bg="white" borderRadius="md" boxShadow="md" overflow="hidden">
            <Flex
              bg="#0F3D2E"
              p={3}
              justify="space-between"
              align="center"
              gap={2}
            >
              <ButtonGroup size="sm" isAttached flex="1">
                <Button
                  flex="1"
                  bg={kot === "Kot" ? "white" : "whiteAlpha.300"}
                  color={kot === "Kot" ? "#0F3D2E" : "white"}
                  onClick={() => setKot("Kot")}
                  _hover={{ bg: kot === "Kot" ? "white" : "whiteAlpha.400" }}
                >
                  KOT
                </Button>
                <Button
                  flex="1"
                  bg={kot === "quick" ? "white" : "whiteAlpha.300"}
                  color={kot === "quick" ? "#0F3D2E" : "white"}
                  onClick={() => setKot("quick")}
                  _hover={{ bg: kot === "quick" ? "white" : "whiteAlpha.400" }}
                >
                  Bill
                </Button>
              </ButtonGroup>
              <Button size="sm" colorScheme="blue" onClick={handleSwitchTable}>
                Switch
              </Button>
            </Flex>
            {kot === "Kot" ? (
              <>
                <Box bg="gray.50" p={3}>
                  <VStack spacing={2}>
                    <Flex w="full" gap={2}>
                      <Box
                        flex="1"
                        bg="white"
                        p={2}
                        borderRadius="md"
                        border="1px solid"
                        borderColor="gray.200"
                      >
                        <Text fontSize="xs" color="gray.600">
                          KOT No
                        </Text>
                        <Text fontSize="sm" fontWeight="bold">
                          {kotNumber || "New"}
                        </Text>
                      </Box>
                      <Checkbox
                        bg="white"
                        isChecked={kotData.nc}
                        name="nc"
                        p={2}
                        borderRadius="md"
                        border="1px solid"
                        borderColor="gray.200"
                        onChange={handleCheckboxChange1}
                      >
                        <Text fontSize="xs">NC KOT</Text>
                      </Checkbox>
                    </Flex>
                    <Input
                      size="sm"
                      bg="white"
                      placeholder="Table No"
                      value={kotData.tableNo}
                      name="tableNo"
                      onChange={handleKotDataChange}
                    />
                    <Select
                      size="sm"
                      bg="white"
                      name="serverName"
                      value={kotData.serverName}
                      placeholder="Select Waiter"
                      onChange={handleKotDataChange}
                    >
                      {waiterList?.map((waiter) => (
                        <option key={waiter._id} value={waiter.name}>
                          {waiter.name}
                        </option>
                      ))}
                    </Select>
                  </VStack>
                </Box>
                <Box
                  p={3}
                  minHeight="300px"
                  maxHeight="400px"
                  overflowY="auto"
                  bg="white"
                >
                  <VStack spacing={2} align="stretch">
                    {currentTable?.items.map((item, index) => (
                      <Box
                        key={index}
                        p={2}
                        bg="gray.50"
                        borderRadius="md"
                        border="1px solid"
                        borderColor="gray.200"
                      >
                        <Flex justify="space-between" align="center" mb={2}>
                          <Text fontSize="sm" fontWeight="medium" flex="1">
                            {item.name}
                          </Text>
                          <Button
                            size="xs"
                            colorScheme="red"
                            variant="ghost"
                            onClick={() => handleDeleteItem(index)}
                          >
                            <FaTrash />
                          </Button>
                        </Flex>
                        <Flex gap={2} align="center">
                          <ButtonGroup size="xs" isAttached>
                            <Button
                              onClick={() =>
                                handleQuantityChange(
                                  index,
                                  Math.max(0, item.quantity - 1),
                                )
                              }
                              isDisabled={item.quantity <= 0}
                            >
                              <FaMinus />
                            </Button>
                            <Input
                              type="number"
                              value={item.quantity}
                              onChange={(e) =>
                                handleQuantityChange(
                                  index,
                                  parseInt(e.target.value) || 0,
                                )
                              }
                              width="50px"
                              textAlign="center"
                              size="xs"
                            />
                            <Button
                              onClick={() =>
                                handleQuantityChange(index, item.quantity + 1)
                              }
                            >
                              <FaPlus />
                            </Button>
                          </ButtonGroup>
                          <Input
                            size="xs"
                            placeholder="Note"
                            flex="1"
                            onChange={(e) => changeNote(index, e.target.value)}
                            value={item.note}
                          />
                          <Flex align="center" gap={1}>
                            <FaRupeeSign size="12px" />
                            <Input
                              size="xs"
                              width="60px"
                              value={item.price}
                              onChange={(e) =>
                                handlePriceChange(index, e.target.value)
                              }
                            />
                          </Flex>
                        </Flex>
                      </Box>
                    ))}
                  </VStack>
                </Box>
                <Box
                  bg="gray.50"
                  p={3}
                  borderTop="1px solid"
                  borderColor="gray.200"
                >
                  <Flex gap={2}>
                    <Button
                      size="sm"
                      colorScheme="green"
                      flex="1"
                      isDisabled={kotNumber !== ""}
                      onClick={() => {
                        const existingData =
                          JSON.parse(localStorage.getItem("kotPrints")) || [];
                        const index = existingData.findIndex(
                          (item) => item.tableNo === tableNo,
                        );
                        if (index !== -1) {
                          existingData[index].serverName = kotData.serverName;
                        } else {
                          existingData.push({
                            tableNo,
                            serverName: kotData.serverName,
                          });
                        }
                        localStorage.setItem(
                          "kotPrints",
                          JSON.stringify(existingData),
                        );
                        kotPrint();
                        startTimer();
                      }}
                    >
                      Save & Print
                    </Button>
                    <Button size="sm" colorScheme="blue" onClick={kotUpdate}>
                      Update
                    </Button>
                    <Button
                      size="sm"
                      colorScheme="red"
                      onClick={() => handleClearBills(tableNo)}
                    >
                      Clear
                    </Button>
                  </Flex>
                </Box>
              </>
            ) : kot === "bill" ? (
              <>
                <Box
                  bg="#F74C31"
                  height="100px"
                  display="flex"
                  p={10}
                  borderRadius="4px"
                  justifyContent="space-between"
                  overflowY="hidden"
                  color="white"
                  alignItems="center"
                >
                  <Select
                    width="150px"
                    value={select}
                    bg="white"
                    color="black"
                    onChange={handleSelect}
                    mr={2}
                  >
                    <option value={"gst"}>Gst</option>
                    <option value={"non-gst"}>Non-Gst</option>
                  </Select>
                  <Input
                    width="150px"
                    bg="white"
                    placeholder="Enter registration"
                    value={formData.registration}
                    name="registration"
                    color="black"
                    onChange={handleInputChange}
                  />
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  p={2}
                  justifyContent="space-evenly"
                  minHeight="250px"
                  overflowY="scroll"
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    p={2}
                  >
                    <TableContainer>
                      <Table variant="simple">
                        <TableCaption>Bill Data</TableCaption>
                        <Thead>
                          <Tr>
                            <Th>Item</Th>
                            <Th>Quantity</Th>
                            <Th>Price</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {currentTable?.items.map((item) => (
                            <Tr key={item._id}>
                              <Td>{item.name}</Td>
                              <Td>{item.quantity}</Td>
                              <Td>{item.price}</Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
                <Box
                  bg="#F74C31"
                  height="fit-content"
                  display="flex"
                  flexDirection="row"
                  p={5}
                  borderRadius="4px"
                  justifyContent="space-between"
                  overflowY="hidden"
                  color="white"
                  alignItems="center"
                >
                  <Text display="flex" alignItems="center" as="b">
                    Total- <FaRupeeSign mt={2} /> {totalSum}
                  </Text>

                  <Button
                    as="b"
                    colorScheme="blue"
                    onClick={handleSaveAndPrint}
                  >
                    Submit
                  </Button>
                  <Button as="b" colorScheme="blue" onClick={save}>
                    Save
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box bg="gray.50" p={3}>
                  <Select
                    size="sm"
                    value={select}
                    bg="white"
                    onChange={handleSelect}
                  >
                    <option value={"gst"}>GST Bill</option>
                    <option value={"non-gst"}>Non-GST Bill</option>
                  </Select>
                </Box>
                <Box
                  p={3}
                  h="200px" // Fixed height
                  overflowY="auto"
                  overflowX="hidden"
                  bg="white"
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius="md"
                >
                  <Table size="sm" variant="simple">
                    <Thead position="sticky" top={0} bg="white" zIndex={1}>
                      <Tr>
                        <Th fontSize="xs">Item</Th>
                        <Th fontSize="xs" isNumeric>
                          Qty
                        </Th>
                        <Th fontSize="xs" isNumeric>
                          Price
                        </Th>
                      </Tr>
                    </Thead>

                    <Tbody>
                      {arr1?.map((item, idx) => (
                        <Tr key={idx}>
                          <Td fontSize="xs">{item.name}</Td>
                          <Td fontSize="xs" isNumeric>
                            {item.quantity}
                          </Td>
                          <Td fontSize="xs" isNumeric>
                            ₹{item.price}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Box>
                <Box bg="gray.50" p={3}>
                  <VStack spacing={2}>
                    <Flex gap={2} w="full">
                      <Input
                        size="sm"
                        bg="white"
                        placeholder="Name"
                        value={quickBill.name}
                        name="name"
                        onChange={handleQuickDataChange}
                      />
                      <Input
                        size="sm"
                        bg="white"
                        placeholder="Phone"
                        value={quickBill.phoneNo}
                        name="phoneNo"
                        onChange={handleQuickDataChange}
                      />
                    </Flex>
                    <Flex gap={2} w="full">
                      <Input
                        size="sm"
                        bg="white"
                        placeholder="Cash Discount"
                        value={quickBill.discount}
                        name="discount"
                        onChange={handleQuickDataChange}
                      />
                      <Input
                        size="sm"
                        bg="white"
                        placeholder="Discount %"
                        value={quickBill.discountPercentage}
                        name="discountPercentage"
                        onChange={handleQuickDataChange}
                      />
                    </Flex>
                    <Flex gap={2} w="full">
                      <Input
                        size="sm"
                        bg="white"
                        placeholder="Wine Discount %"
                        value={quickBill.wineDiscount}
                        name="wineDiscount"
                        onChange={handleQuickDataChange}
                      />
                      <Input
                        size="sm"
                        bg="white"
                        placeholder="Food Discount %"
                        value={quickBill.foodDiscount}
                        name="foodDiscount"
                        onChange={handleQuickDataChange}
                      />
                    </Flex>
                    <Input
                      size="sm"
                      bg="white"
                      placeholder="Remarks"
                      value={quickBill.remark}
                      name="remark"
                      onChange={handleQuickDataChange}
                    />
                    <Select
                      size="sm"
                      bg="white"
                      placeholder="Payment Mode"
                      value={quickBill.mode}
                      name="mode"
                      onChange={handleQuickDataChange}
                    >
                      <option value="Phonepe">Phonepe</option>
                      <option value="GooglePe">Googlepe</option>
                      <option value="Paytm">Paytm</option>
                      <option value="Upi">Upi</option>
                    </Select>
                    {quickBill.mode && quickBill.mode !== "Card" && (
                      <Input
                        size="sm"
                        bg="white"
                        placeholder="Transaction ID"
                        value={quickBill.transactionId}
                        name="transactionId"
                        onChange={handleQuickDataChange}
                      />
                    )}
                    {quickBill.mode && (
                      <InputGroup size="sm">
                        <InputLeftAddon>Online</InputLeftAddon>
                        <Input
                          bg="white"
                          placeholder={
                            quickBill.mode !== "Card"
                              ? "Online Amount"
                              : "Card Amount"
                          }
                          value={quickBill.online}
                          onFocus={onLineFoucus}
                          name="online"
                          onChange={handleQuickDataChange}
                        />
                      </InputGroup>
                    )}
                    {quickBill.mode === "Card" && (
                      <>
                        <Input
                          size="sm"
                          bg="white"
                          placeholder="Card Last 4 Digits"
                          value={quickBill.cardNo}
                          name="cardNo"
                          onChange={handleQuickDataChange}
                        />
                        <Input
                          size="sm"
                          bg="white"
                          placeholder="Bank Name"
                          value={quickBill.bankName}
                          name="bankName"
                          onChange={handleQuickDataChange}
                        />
                      </>
                    )}
                    <InputGroup size="sm">
                      <InputLeftAddon>Cash</InputLeftAddon>
                      <Input
                        bg="white"
                        placeholder="Cash Amount"
                        value={quickBill.cash}
                        onFocus={cashFoucus}
                        name="cash"
                        onChange={handleQuickDataChange}
                      />
                    </InputGroup>
                    <InputGroup size="sm">
                      <InputLeftAddon>Card</InputLeftAddon>
                      <Input
                        bg="white"
                        placeholder="Card Amount"
                        value={quickBill.card}
                        name="card"
                        onChange={handleQuickDataChange}
                      />
                    </InputGroup>
                    <InputGroup size="sm">
                      <InputLeftAddon>Due</InputLeftAddon>
                      <Input
                        bg="white"
                        placeholder="Due Amount"
                        value={quickBill.due}
                        name="due"
                        onChange={handleQuickDataChange}
                      />
                    </InputGroup>
                  </VStack>
                </Box>
                <Box bg="gray.800" p={3}>
                  <Flex justify="space-between" align="center" mb={3}>
                    <Text color="white" fontWeight="bold" fontSize="lg">
                      Total: ₹{Math.round(cashDiscount)}
                    </Text>
                  </Flex>
                  <Flex gap={2}>
                    <Button
                      size="sm"
                      colorScheme="blue"
                      onClick={quickSave}
                      flex="1"
                    >
                      Save
                    </Button>
                    {printData[0]?.splitBill === true ? (
                      <>
                        <Button size="sm" colorScheme="green" onClick={print1}>
                          Food
                        </Button>
                        <Button size="sm" colorScheme="green" onClick={print2}>
                          Wine
                        </Button>
                      </>
                    ) : (
                      <Button size="sm" colorScheme="green" onClick={print}>
                        Print
                      </Button>
                    )}
                    <Button
                      size="sm"
                      colorScheme="red"
                      onClick={qSave}
                      flex="1"
                    >
                      Submit
                    </Button>
                  </Flex>
                </Box>
              </>
            )}
          </Box>
          {arr[0] ? (
            printData[0]?.splitBill === true ? (
              <Box display="none">
                <Card
                  mt={5}
                  textAlign="center"
                  boxShadow="dark-lg"
                  ref={componentRef1}
                  width="3in"
                  padding="0.3in"
                >
                  <CardHeader
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                    p={2}
                    boxShadow="md"
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      gap={2}
                    >
                      {printData.map((item) => (
                        <Box
                          key={item._id}
                          textAlign="center"
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Image src={item.imageUrl} w="90px" h="60px" />
                          <h4>
                            <b>{item.name}</b>
                          </h4>
                          <Text fontSize="xs">{item.adress}</Text>
                          <Text fontSize="xs">{item.phoneNo}</Text>
                          <Text fontSize="xs">{item.website}</Text>
                          {item.gstNo ? (
                            <Text fontSize="xs">GstIn-{item.gstNo}</Text>
                          ) : (
                            ""
                          )}
                          {item.fssaiNo ? (
                            <Text fontSize="xs">FssaiNo-{item.fssaiNo}</Text>
                          ) : (
                            ""
                          )}
                        </Box>
                      ))}
                    </Box>
                  </CardHeader>
                  <Box
                    p={2}
                    textAlign="center"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    gap={2}
                  >
                    <Text>Name: {quickBill.name}</Text>
                    <Text>Phone: {quickBill.phoneNo}</Text>
                    <Box
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      gap={3}
                      justifyContent="space-evenly"
                    >
                      <Text fontSize="12px">Table: {quickBill.tableNo}</Text>
                      <Text fontSize="12px">Bill: {quickBill.billNo}</Text>
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      gap={3}
                      justifyContent="space-evenly"
                    >
                      <Text fontSize="12px">Date: {newDate[1]}</Text>
                      <Text fontSize="12px">Time: {newDate[2]}</Text>
                    </Box>
                    {serverName ? (
                      <Text fontSize="12px">Server-{serverName}</Text>
                    ) : (
                      ""
                    )}
                  </Box>

                  <Text as="b" mb={2}>
                    {" "}
                    # Food Items #
                  </Text>

                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "11px",
                      textAlign: "left",
                      marginBottom: "2px",
                      padding: "5px",
                    }}
                  >
                    {/* <TableCaption>Food Data</TableCaption> */}
                    <thead>
                      <tr>
                        <th
                          fontSize="10px"
                          style={{ borderBottom: "1px dotted black" }}
                        >
                          Items Name
                        </th>
                        {hsnView ? (
                          <th
                            fontSize="10px"
                            style={{ borderBottom: "1px dotted black" }}
                          >
                            Hsn/Sac
                          </th>
                        ) : (
                          ""
                        )}
                        <th
                          fontSize="10px"
                          style={{ borderBottom: "1px dotted black" }}
                        >
                          Rate
                        </th>
                        <th
                          fontSize="10px"
                          style={{ borderBottom: "1px dotted black" }}
                        >
                          Qty
                        </th>

                        <th
                          fontSize="10px"
                          style={{ borderBottom: "1px dotted black" }}
                        >
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {arr3?.map((item, index) => (
                        <tr key={index}>
                          <td
                            fontSize="9px"
                            style={{ borderBottom: "1px dotted black" }}
                          >
                            {item.name}
                          </td>
                          {hsnView ? (
                            <td
                              fontSize="9px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              {item.hsnNo}
                            </td>
                          ) : (
                            ""
                          )}
                          <td
                            fontSize="9px"
                            style={{ borderBottom: "1px dotted black" }}
                          >
                            {item.price / item.quantity}
                          </td>
                          <td
                            fontSize="9px"
                            style={{ borderBottom: "1px dotted black" }}
                          >
                            {item.quantity}
                          </td>

                          <td
                            fontSize="9px"
                            style={{ borderBottom: "1px dotted black" }}
                          >
                            {item.price}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      {quickBill.foodDiscount && quickBill.foodDiscount > 0 ? (
                        <tr>
                          <td
                            colSpan={5}
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              borderBottom: "1px dotted black",
                              paddingRight: "15px",
                            }}
                          >
                            Items Total:{" "}
                            {arr3?.reduce((acc, item) => acc + item.price, 0)}
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                      {quickBill.foodDiscount && quickBill.foodDiscount > 0 ? (
                        <tr>
                          <td
                            colSpan={5}
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              borderBottom: "1px dotted black",
                              paddingRight: "15px",
                            }}
                          >
                            Add @ {quickBill.foodDiscount} % Discount:{" "}
                            {(
                              arr3?.reduce((acc, item) => acc + item.price, 0) -
                              taxableAmount
                            ).toFixed(2)}
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                      {isHappyHour && happyDiscount > 0 ? (
                        <tr>
                          <td
                            colSpan={5}
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              borderBottom: "1px dotted black",
                              paddingRight: "15px",
                            }}
                          >
                            Add @ {happyDiscount} % Happy Discount:{" "}
                            {(
                              arr3?.reduce((acc, item) => acc + item.price, 0) -
                              taxableAmount
                            ).toFixed(2)}
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            borderBottom: "1px dotted black",
                            paddingRight: "15px",
                          }}
                        >
                          Gross Total: {taxableAmount}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            borderBottom: "1px dotted black",
                            paddingRight: "15px",
                          }}
                        >
                          Add CGST on Gross: {rsgst}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            borderBottom: "1px dotted black",
                            paddingRight: "15px",
                          }}
                        >
                          Add SGST on Gross: {rcgst}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            borderBottom: "1px dotted black",
                            paddingRight: "15px",
                          }}
                        >
                          Total GST: {(rcgst * 2).toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            borderBottom: "1px dotted black",
                            paddingRight: "15px",
                          }}
                        >
                          Food Total:{" "}
                          {(taxableAmount + rcgst + rsgst).toFixed(2)}
                        </td>
                      </tr>
                      {roundOff > 0 ? (
                        <tr>
                          <td
                            colSpan={5}
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              borderBottom: "1px dotted black",
                              paddingRight: "15px",
                            }}
                          >
                            Round Off: {roundOff}
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                    </tfoot>
                  </table>

                  <Box
                    display="flex"
                    flexDirection="column"
                    p={2}
                    textAlign="center"
                    borderBottom="1px dotted black"
                  >
                    {printData.map((item) => (
                      <>
                        <Text
                          key={item._id}
                          as="b"
                          fontSize="14px"
                          textAlign="right"
                        >
                          {!quickBill.foodDiscount ? "Net" : ""} Gross Total
                          Amount-{" "}
                          {quickBill.isComplementary
                            ? 0
                            : Math.round(taxableAmount + rcgst + rsgst).toFixed(
                                2,
                              )}
                        </Text>
                        {/* <Text key={item.name} as='b' fontSize='14px' textAlign='right' >
               5% GST Total- {rcgst+rsgst} 
            </Text> */}
                        {/* <Text fontSize='12px' textAlign='right' >{quickBill.wineDiscount? `Wine Discount % ${quickBill.wineDiscount}`:""}</Text>
            <Text fontSize='12px' textAlign='right' >{quickBill.foodDiscount? `Food Discount % ${quickBill.foodDiscount}`:""}</Text> */}
                        {/* <Text key={item.name} as='b' fontSize='14px' textAlign='right' >
            {quickBill.discount || quickBill.discountPercentage ?"":"Net"} Total Amount- {quickBill.isComplementary ? 0 :totalSum} 
            </Text>
            <Text fontSize='12px' textAlign='right' >{quickBill.discount? `Cash Discount ${quickBill.discount}`:""}</Text>

            <Text fontSize='12px' textAlign='right'>{quickBill.discountPercentage? `Discount% ${quickBill.discountPercentage}`:""}</Text> */}

                        {/* {quickBill.discount || quickBill.discountPercentage ? <Text key={item.name} as='b' fontSize='14px' textAlign='right' >
              Net Total- {(taxableAmount+rcgst+rsgst).toFixed(2)} 
            </Text>:""} */}
                      </>
                    ))}
                  </Box>

                  <Box
                    display="flex"
                    flexDirection="column"
                    p={2}
                    textAlign="left"
                    borderBottom="1px dotted black"
                  >
                    {printData.map((item) => (
                      <>
                        <Text
                          key={item._id}
                          as="b"
                          fontSize="10px"
                          textAlign="left"
                        >
                          Total Amount (INR - In Words):{" "}
                          {quickBill.isComplementary
                            ? 0
                            : totalSum
                            ? numberToWords(
                                Math.round(
                                  taxableAmount + rcgst + rsgst,
                                ).toFixed(2),
                              )
                            : "Zero"}
                        </Text>
                      </>
                    ))}
                  </Box>
                  {/* <Box display='flex' alignItems='center' justifyContent='center' textAlign='left' flexDirection='row' p={2}>
          <Box display='flex' flexDirection='column' border='1px solid black' p={1} fontSize='12px'>
            <Text borderBottom='1px solid black' bg='yellow.200' fontSize='12px'>Summary</Text>
            <Text fontSize='12px'>Total Rate</Text>
         {wineItems && wineItems.length>0 ?   <Text fontSize='12px'>Wine Rate</Text> : ""}
            
            <Text fontSize='12px'>Food Rate</Text>
           
            <Text fontSize='12px'>Food CGST</Text>
            <Text fontSize='12px'>Food SGST</Text>
            <Text fontSize='12px'>Grand Total</Text>
          </Box>
          <Box display='flex' flexDirection='column' textAlign='left' alignItems='left' justifyContent='left' border='1px solid black' p={1}>
            <Text borderBottom='1px solid black' bg='gray.200' fontSize='12px'>Amount</Text>
            <Text fontSize='12px'>{totalAmount}</Text>
           {wineItems && wineItems.length > 0 ? <Text fontSize='12px'>{wineAmount}</Text> :""}
            <Text fontSize='12px'>{taxableAmount}</Text>
            <Text fontSize='12px'>{rcgst}</Text>
            <Text fontSize='12px'>{rsgst}</Text>
            <Text fontSize='12px' borderTop='1px solid black'>{totalSum}</Text>
          </Box>
          
        </Box> */}
                  {/* <Box display='flex' flexDirection='column' textAlign='left' justifyContent='left' alignItems='left'  mb={2} gap='1'>
        {quickBill.cash? <Text as='b' display='flex'  justifyContent='center' alignItems='center' fontFamily='sans-serif'>Cash -<FaRupeeSign/> {quickBill.cash}</Text>: ""}
          {quickBill.online? <Text as='b' display='flex'  justifyContent='center' alignItems='center' fontFamily='sans-serif'>{quickBill.mode} - <FaRupeeSign/>{quickBill.online}</Text>: ""}
          {quickBill.due && quickBill.due != 0 || null ? <Text as='b' display='flex'  justifyContent='center' alignItems='center' fontFamily='sans-serif'>Due - <FaRupeeSign/>{quickBill.due}</Text>: ""}
          {quickBill.remark ? <Text as='b' display='flex'  justifyContent='center' alignItems='center' fontFamily='sans-serif' >Remark-{quickBill.remark}</Text>:"" }
          </Box> */}
                  <CardFooter
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    p={2}
                    textAlign="center"
                  >
                    {/* <h4 ><b>Cash is not refundable</b></h4> */}
                    <Text as="b">Thank You</Text>
                    <Text as="b">Visit again</Text>
                  </CardFooter>
                </Card>
                <Card
                  mt={5}
                  textAlign="center"
                  boxShadow="dark-lg"
                  ref={componentRef2}
                  width="3in"
                  padding="0.3in"
                >
                  <CardHeader
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                    p={2}
                    boxShadow="md"
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      gap={2}
                    >
                      {printData.map((item) => (
                        <Box
                          key={item._id}
                          textAlign="center"
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Image src={item.imageUrl} w="90px" h="60px" />
                          <h4>
                            <b>{item.name}</b>
                          </h4>
                          <Text fontSize="xs">{item.adress}</Text>
                          <Text fontSize="xs">{item.phoneNo}</Text>
                          <Text fontSize="xs">{item.website}</Text>
                          {item.gstNo ? (
                            <Text fontSize="xs">GstIn-{item.gstNo}</Text>
                          ) : (
                            ""
                          )}
                          {item.fssaiNo ? (
                            <Text fontSize="xs">FssaiNo-{item.fssaiNo}</Text>
                          ) : (
                            ""
                          )}
                        </Box>
                      ))}
                    </Box>
                  </CardHeader>
                  <Box
                    p={2}
                    textAlign="center"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    gap={2}
                  >
                    {/* <Text>Name: {quickBill.name}</Text>
          <Text>Phone: {quickBill.phoneNo}</Text> */}
                    <Box
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      gap={3}
                      justifyContent="space-evenly"
                    >
                      <Text fontSize="12px">Table: {quickBill.tableNo}</Text>
                      <Text fontSize="12px">Bill: {quickBill.billNo}</Text>
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      gap={3}
                      justifyContent="space-evenly"
                    >
                      <Text fontSize="12px">Date: {newDate[1]}</Text>
                      <Text fontSize="12px">Time: {newDate[2]}</Text>
                    </Box>
                    {serverName ? (
                      <Text fontSize="12px">Server-{serverName}</Text>
                    ) : (
                      ""
                    )}
                  </Box>
                  {wineItems && wineItems?.length > 0 ? (
                    <>
                      {" "}
                      <Text as="b" mb={2}>
                        # Wine Items #
                      </Text>{" "}
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "11px",
                          marginBottom: "2px",
                          textAlign: "left",
                          padding: "5px",
                        }}
                      >
                        {/* <TableCaption>Wine Data</TableCaption> */}
                        <thead>
                          <tr>
                            <th
                              fontSize="10px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              Items Name
                            </th>
                            <th
                              fontSize="10px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              Rate
                            </th>
                            <th
                              fontSize="10px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              Qty
                            </th>
                            <th
                              fontSize="10px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              Unit
                            </th>
                            <th
                              fontSize="10px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {arr2?.map((item, index) => (
                            <tr key={index}>
                              {/* <td fontSize='9px' style={{borderBottom:"1px dotted black"}}>{index+1}</td > */}
                              <td
                                fontSize="9px"
                                style={{ borderBottom: "1px dotted black" }}
                              >
                                {item.name}
                              </td>
                              <td
                                fontSize="9px"
                                style={{ borderBottom: "1px dotted black" }}
                              >
                                {item.price / item.quantity}
                              </td>
                              <td
                                fontSize="9px"
                                style={{ borderBottom: "1px dotted black" }}
                              >
                                {item.quantity}
                              </td>
                              <td
                                fontSize="9px"
                                style={{ borderBottom: "1px dotted black" }}
                              >
                                {item.unit}
                              </td>
                              <td
                                fontSize="9px"
                                style={{ borderBottom: "1px dotted black" }}
                              >
                                {item.price}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td
                              colSpan={5}
                              style={{
                                textAlign: "right",
                                fontSize: "12px",
                                borderBottom: "1px dotted black",
                                paddingRight: "15px",
                              }}
                            >
                              Gross Total:{" "}
                              {arr2.reduce((acc, item) => acc + item.price, 0)}
                            </td>
                          </tr>
                          {quickBill.wineDiscount &&
                          quickBill.wineDiscount > 0 ? (
                            <tr>
                              <td
                                colSpan={5}
                                style={{
                                  textAlign: "right",
                                  fontSize: "12px",
                                  borderBottom: "1px dotted black",
                                  paddingRight: "15px",
                                }}
                              >
                                Add @ {quickBill.wineDiscount}% Discount:{" "}
                                {(
                                  arr2.reduce(
                                    (acc, item) => acc + item.price,
                                    0,
                                  ) - wineAmount
                                ).toFixed(2)}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                          {isHappyHour && happyDiscount > 0 ? (
                            <tr>
                              <td
                                colSpan={5}
                                style={{
                                  textAlign: "right",
                                  fontSize: "12px",
                                  borderBottom: "1px dotted black",
                                  paddingRight: "15px",
                                }}
                              >
                                Add @ {happyDiscount}% Happy Discount:{" "}
                                {(
                                  arr2.reduce(
                                    (acc, item) => acc + item.price,
                                    0,
                                  ) - wineAmount
                                ).toFixed(2)}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                          <tr>
                            <td
                              colSpan={5}
                              style={{
                                textAlign: "right",
                                fontSize: "12px",
                                borderBottom: "1px dotted black",
                                paddingRight: "15px",
                              }}
                            >
                              Drinks Total: {wineAmount}
                            </td>
                          </tr>
                        </tfoot>
                      </table>{" "}
                    </>
                  ) : (
                    ""
                  )}

                  <Box
                    display="flex"
                    flexDirection="column"
                    p={2}
                    textAlign="center"
                    borderBottom="1px dotted black"
                  >
                    {printData.map((item) => (
                      <>
                        <Text
                          key={item._id}
                          as="b"
                          fontSize="14px"
                          textAlign="right"
                        >
                          Gross Total Amount-{" "}
                          {quickBill.isComplementary
                            ? 0
                            : wineAmount.toFixed(2)}
                        </Text>
                      </>
                    ))}
                  </Box>

                  <Box
                    display="flex"
                    flexDirection="column"
                    p={2}
                    textAlign="left"
                    borderBottom="1px dotted black"
                  >
                    {printData.map((item) => (
                      <>
                        <Text
                          key={item._id}
                          as="b"
                          fontSize="10px"
                          textAlign="left"
                        >
                          Total Amount (INR - In Words):{" "}
                          {quickBill.isComplementary
                            ? 0
                            : totalSum
                            ? numberToWords(wineAmount)
                            : "Zero"}
                        </Text>
                      </>
                    ))}
                  </Box>
                  {/* <Box display='flex' alignItems='center' justifyContent='center' textAlign='left' flexDirection='row' p={2}>
          <Box display='flex' flexDirection='column' border='1px solid black' p={1} fontSize='12px'>
            <Text borderBottom='1px solid black' bg='yellow.200' fontSize='12px'>Summary</Text>
            <Text fontSize='12px'>Total Rate</Text>
         {wineItems && wineItems.length>0 ?   <Text fontSize='12px'>Wine Rate</Text> : ""}
            
            <Text fontSize='12px'>Food Rate</Text>
           
            <Text fontSize='12px'>Food CGST</Text>
            <Text fontSize='12px'>Food SGST</Text>
            <Text fontSize='12px'>Grand Total</Text>
          </Box>
          <Box display='flex' flexDirection='column' textAlign='left' alignItems='left' justifyContent='left' border='1px solid black' p={1}>
            <Text borderBottom='1px solid black' bg='gray.200' fontSize='12px'>Amount</Text>
            <Text fontSize='12px'>{totalAmount}</Text>
           {wineItems && wineItems.length > 0 ? <Text fontSize='12px'>{wineAmount}</Text> :""}
            <Text fontSize='12px'>{taxableAmount}</Text>
            <Text fontSize='12px'>{rcgst}</Text>
            <Text fontSize='12px'>{rsgst}</Text>
            <Text fontSize='12px' borderTop='1px solid black'>{totalSum}</Text>
          </Box>
          
        </Box> */}
                  {/* <Box display='flex' flexDirection='column' textAlign='left' justifyContent='left' alignItems='left'  mb={2} gap='1'>
        {quickBill.cash? <Text as='b' display='flex'  justifyContent='center' alignItems='center' fontFamily='sans-serif'>Cash -<FaRupeeSign/> {quickBill.cash}</Text>: ""}
          {quickBill.online? <Text as='b' display='flex'  justifyContent='center' alignItems='center' fontFamily='sans-serif'>{quickBill.mode} - <FaRupeeSign/>{quickBill.online}</Text>: ""}
          {quickBill.due && quickBill.due != 0 || null ? <Text as='b' display='flex'  justifyContent='center' alignItems='center' fontFamily='sans-serif'>Due - <FaRupeeSign/>{quickBill.due}</Text>: ""}
          {quickBill.remark ? <Text as='b' display='flex'  justifyContent='center' alignItems='center' fontFamily='sans-serif' >Remark-{quickBill.remark}</Text>:"" }
          </Box> */}
                  <CardFooter
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    p={2}
                    textAlign="center"
                  >
                    {/* <h4 ><b>Cash is not refundable</b></h4> */}
                    <Text as="b">Thank You</Text>
                    <Text as="b">Visit again</Text>
                  </CardFooter>
                </Card>
              </Box>
            ) : (
              <Box display="none">
                <Card
                  mt={5}
                  textAlign="center"
                  boxShadow="dark-lg"
                  ref={componentRef}
                  width="3in"
                  padding="0.3in"
                >
                  <CardHeader
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                    p={2}
                    boxShadow="md"
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      gap={2}
                    >
                      {printData.map((item) => (
                        <Box
                          key={item._id}
                          textAlign="center"
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <h4>
                            <b>{item.name}</b>
                          </h4>
                          <Text fontSize="xs">{item.adress}</Text>
                          <Text fontSize="xs">{item.phoneNo}</Text>
                          <Text fontSize="xs">{item.website}</Text>
                          {item.gstNo ? (
                            <Text fontSize="xs">GstIn-{item.gstNo}</Text>
                          ) : (
                            ""
                          )}
                          {item.fssaiNo ? (
                            <Text fontSize="xs">FssaiNo-{item.fssaiNo}</Text>
                          ) : (
                            ""
                          )}
                        </Box>
                      ))}
                    </Box>
                  </CardHeader>
                  <Box
                    p={2}
                    textAlign="center"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    gap={2}
                  >
                    {/* <Text>Name: {quickBill.name}</Text>
          <Text>Phone: {quickBill.phoneNo}</Text>  */}
                    <Box
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      gap={3}
                      justifyContent="space-evenly"
                    >
                      <Text fontSize="12px">Table: {quickBill.tableNo}</Text>
                      <Text fontSize="12px">Bill: {quickBill.billNo}</Text>
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      gap={3}
                      justifyContent="space-evenly"
                    >
                      <Text fontSize="12px">Date: {newDate[1]}</Text>
                      <Text fontSize="12px">Time: {newDate[2]}</Text>
                    </Box>
                    {kotData.serverName && (
                      <Text fontSize="12px">Server - {kotData.serverName}</Text>
                    )}
                  </Box>
                  {wineItems && wineItems?.length > 0 ? (
                    <>
                      {" "}
                      <Text as="b" mb={2}>
                        # Wine Items #
                      </Text>{" "}
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "11px",
                          marginBottom: "2px",
                          textAlign: "left",
                          padding: "5px",
                        }}
                      >
                        {/* <TableCaption>Wine Data</TableCaption> */}
                        <thead>
                          <tr>
                            <th
                              fontSize="10px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              Items Name
                            </th>
                            <th
                              fontSize="10px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              Rate
                            </th>
                            <th
                              fontSize="10px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              Qty
                            </th>
                            <th
                              fontSize="10px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              Unit
                            </th>
                            <th
                              fontSize="10px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {arr2?.map((item, index) => (
                            <tr key={index}>
                              {/* <td fontSize='9px' style={{borderBottom:"1px dotted black"}}>{index+1}</td > */}
                              <td
                                fontSize="9px"
                                style={{ borderBottom: "1px dotted black" }}
                              >
                                {item.name}
                              </td>
                              <td
                                fontSize="9px"
                                style={{ borderBottom: "1px dotted black" }}
                              >
                                {item.price / item.quantity}
                              </td>
                              <td
                                fontSize="9px"
                                style={{ borderBottom: "1px dotted black" }}
                              >
                                {item.quantity}
                              </td>
                              <td
                                fontSize="9px"
                                style={{ borderBottom: "1px dotted black" }}
                              >
                                {item.unit}
                              </td>
                              <td
                                fontSize="9px"
                                style={{ borderBottom: "1px dotted black" }}
                              >
                                {item.price}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td
                              colSpan={5}
                              style={{
                                textAlign: "right",
                                fontSize: "12px",
                                borderBottom: "1px dotted black",
                                paddingRight: "15px",
                              }}
                            >
                              Gross Total:{" "}
                              {arr2.reduce((acc, item) => acc + item.price, 0)}
                            </td>
                          </tr>
                          {quickBill.wineDiscount &&
                          quickBill.wineDiscount > 0 ? (
                            <tr>
                              <td
                                colSpan={5}
                                style={{
                                  textAlign: "right",
                                  fontSize: "12px",
                                  borderBottom: "1px dotted black",
                                  paddingRight: "15px",
                                }}
                              >
                                Add @ {quickBill.wineDiscount}% Discount:{" "}
                                {(
                                  arr2.reduce(
                                    (acc, item) => acc + item.price,
                                    0,
                                  ) - wineAmount
                                ).toFixed(2)}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                          <tr>
                            <td
                              colSpan={5}
                              style={{
                                textAlign: "right",
                                fontSize: "12px",
                                borderBottom: "1px dotted black",
                                paddingRight: "15px",
                              }}
                            >
                              Drinks Total: {wineAmount}
                            </td>
                          </tr>
                        </tfoot>
                      </table>{" "}
                    </>
                  ) : (
                    ""
                  )}

                  <Text as="b" mb={2}>
                    {" "}
                    # Food Items #
                  </Text>

                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "11px",
                      textAlign: "left",
                      marginBottom: "2px",
                      padding: "5px",
                    }}
                  >
                    {/* <TableCaption>Food Data</TableCaption> */}
                    <thead>
                      <tr>
                        <th
                          fontSize="10px"
                          style={{ borderBottom: "1px dotted black" }}
                        >
                          Items Name
                        </th>
                        {select === "gst" && hsnView ? (
                          <th
                            fontSize="10px"
                            style={{ borderBottom: "1px dotted black" }}
                          >
                            Hsn/Sac
                          </th>
                        ) : (
                          ""
                        )}
                        <th
                          fontSize="10px"
                          style={{ borderBottom: "1px dotted black" }}
                        >
                          Rate
                        </th>
                        <th
                          fontSize="10px"
                          style={{ borderBottom: "1px dotted black" }}
                        >
                          Qty
                        </th>

                        <th
                          fontSize="10px"
                          style={{ borderBottom: "1px dotted black" }}
                        >
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {arr3?.map((item, index) => (
                        <tr key={index}>
                          <td
                            fontSize="9px"
                            style={{ borderBottom: "1px dotted black" }}
                          >
                            {item.name}
                          </td>
                          {select === "gst" && hsnView ? (
                            <td
                              fontSize="9px"
                              style={{ borderBottom: "1px dotted black" }}
                            >
                              {item.hsnNo}
                            </td>
                          ) : null}
                          <td
                            fontSize="9px"
                            style={{ borderBottom: "1px dotted black" }}
                          >
                            {item.price / item.quantity}
                          </td>
                          <td
                            fontSize="9px"
                            style={{ borderBottom: "1px dotted black" }}
                          >
                            {item.quantity}
                          </td>

                          <td
                            fontSize="9px"
                            style={{ borderBottom: "1px dotted black" }}
                          >
                            {item.price}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      {quickBill.foodDiscount && quickBill.foodDiscount > 0 ? (
                        <tr>
                          <td
                            colSpan={5}
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              borderBottom: "1px dotted black",
                              paddingRight: "15px",
                            }}
                          >
                            Items Total:{" "}
                            {arr3?.reduce((acc, item) => acc + item.price, 0)}
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                      {quickBill.foodDiscount && quickBill.foodDiscount > 0 ? (
                        <tr>
                          <td
                            colSpan={5}
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              borderBottom: "1px dotted black",
                              paddingRight: "15px",
                            }}
                          >
                            Add {quickBill.foodDiscount} % Discount:{" "}
                            {(
                              arr3?.reduce((acc, item) => acc + item.price, 0) -
                              taxableAmount
                            ).toFixed(2)}
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            borderBottom: "1px dotted black",
                            paddingRight: "15px",
                          }}
                        >
                          Gross Total: {taxableAmount}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            borderBottom: "1px dotted black",
                            paddingRight: "15px",
                          }}
                        >
                          Add CGST on Gross: {rsgst?.toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            borderBottom: "1px dotted black",
                            paddingRight: "15px",
                          }}
                        >
                          Add SGST on Gross: {rcgst?.toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            borderBottom: "1px dotted black",
                            paddingRight: "15px",
                          }}
                        >
                          Total GST: {(rcgst * 2)?.toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            borderBottom: "1px dotted black",
                            paddingRight: "15px",
                          }}
                        >
                          Food Total:{" "}
                          {(taxableAmount + rcgst + rsgst)?.toFixed(2)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                  <Box
                    display="flex"
                    flexDirection="column"
                    p={2}
                    textAlign="center"
                    borderBottom="1px dotted black"
                  >
                    {printData.map((item) => (
                      <>
                        <Text
                          key={item._id}
                          as="b"
                          fontSize="14px"
                          textAlign="right"
                        >
                          {!quickBill.discount || !quickBill.discountPercentage
                            ? "Net"
                            : ""}{" "}
                          Gross Total Amount-{" "}
                          {(totalSum - (rcgst + rsgst)).toFixed(2)}
                        </Text>
                        <Text
                          key={item._id}
                          as="b"
                          fontSize="14px"
                          textAlign="right"
                        >
                          GST Total- {(rcgst + rsgst)?.toFixed(1)}
                        </Text>
                        {/* <Text fontSize='12px' textAlign='right' >{quickBill.wineDiscount? `Wine Discount % ${quickBill.wineDiscount}`:""}</Text>
            <Text fontSize='12px' textAlign='right' >{quickBill.foodDiscount? `Food Discount % ${quickBill.foodDiscount}`:""}</Text> */}
                        {roundOff > 0 ? (
                          <Text fontSize="12px" textAlign="right">
                            Round off - {roundOff?.toFixed(1)}
                          </Text>
                        ) : (
                          ""
                        )}
                        <Text as="b" fontSize="14px" textAlign="right">
                          {quickBill.discount || quickBill.discountPercentage
                            ? ""
                            : "Net"}{" "}
                          Total Amount-{" "}
                          {quickBill.isComplementary
                            ? 0
                            : parseInt(Math.round(totalSum))}
                        </Text>
                        <Text fontSize="12px" textAlign="right">
                          {quickBill.discount
                            ? `Cash Discount ${quickBill.discount}`
                            : ""}
                        </Text>

                        <Text fontSize="12px" textAlign="right">
                          {quickBill.discountPercentage
                            ? `Discount% ${quickBill.discountPercentage}`
                            : ""}
                        </Text>
                        <Text fontSize="12px" textAlign="right">
                          {isHappyHour
                            ? `Happy Discount% ${happyDiscount}`
                            : ""}
                        </Text>

                        {quickBill.discount ||
                        quickBill.discountPercentage ||
                        isHappyHour ? (
                          <Text
                            key={item._id}
                            as="b"
                            fontSize="14px"
                            textAlign="right"
                          >
                            Net Total- {Math.round(cashDiscount).toFixed(2)}
                          </Text>
                        ) : (
                          ""
                        )}
                      </>
                    ))}
                  </Box>

                  <Box
                    display="flex"
                    flexDirection="column"
                    p={2}
                    textAlign="left"
                    borderBottom="1px dotted black"
                  >
                    {printData.map((item) => (
                      <>
                        <Text
                          key={item._id}
                          as="b"
                          fontSize="10px"
                          textAlign="left"
                        >
                          Total Amount (INR - In Words):{" "}
                          {quickBill.isComplementary
                            ? 0
                            : totalSum
                            ? numberToWords(Math.round(cashDiscount))
                            : "Zero"}
                        </Text>
                      </>
                    ))}
                  </Box>
                  {/* <Box display='flex' alignItems='center' justifyContent='center' textAlign='left' flexDirection='row' p={2}>
          <Box display='flex' flexDirection='column' border='1px solid black' p={1} fontSize='12px'>
            <Text borderBottom='1px solid black' bg='yellow.200' fontSize='12px'>Summary</Text>
            <Text fontSize='12px'>Total Rate</Text>
         {wineItems && wineItems.length>0 ?   <Text fontSize='12px'>Wine Rate</Text> : ""}
            
            <Text fontSize='12px'>Food Rate</Text>
           
            <Text fontSize='12px'>Food CGST</Text>
            <Text fontSize='12px'>Food SGST</Text>
            <Text fontSize='12px'>Grand Total</Text>
          </Box>
          <Box display='flex' flexDirection='column' textAlign='left' alignItems='left' justifyContent='left' border='1px solid black' p={1}>
            <Text borderBottom='1px solid black' bg='gray.200' fontSize='12px'>Amount</Text>
            <Text fontSize='12px'>{totalAmount}</Text>
           {wineItems && wineItems.length > 0 ? <Text fontSize='12px'>{wineAmount}</Text> :""}
            <Text fontSize='12px'>{taxableAmount}</Text>
            <Text fontSize='12px'>{rcgst}</Text>
            <Text fontSize='12px'>{rsgst}</Text>
            <Text fontSize='12px' borderTop='1px solid black'>{totalSum}</Text>
          </Box>
          
        </Box> */}
                  <Box
                    display="flex"
                    flexDirection="column"
                    textAlign="left"
                    justifyContent="left"
                    alignItems="left"
                    mb={2}
                    gap="1"
                  >
                    {quickBill.cash ? (
                      <Text
                        as="b"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        fontFamily="sans-serif"
                      >
                        Cash -<FaRupeeSign /> {quickBill.cash}
                      </Text>
                    ) : (
                      ""
                    )}
                    {quickBill.online ? (
                      <Text
                        as="b"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        fontFamily="sans-serif"
                      >
                        {quickBill.mode} - <FaRupeeSign />
                        {quickBill.online}
                      </Text>
                    ) : (
                      ""
                    )}
                    {(quickBill.card && quickBill.card != 0) || null ? (
                      <Text
                        as="b"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        fontFamily="sans-serif"
                      >
                        Card - <FaRupeeSign />
                        {quickBill.card}
                      </Text>
                    ) : (
                      ""
                    )}
                    {(quickBill.due && quickBill.due != 0) || null ? (
                      <Text
                        as="b"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        fontFamily="sans-serif"
                      >
                        Due - <FaRupeeSign />
                        {quickBill.due}
                      </Text>
                    ) : (
                      ""
                    )}
                    {quickBill.remark ? (
                      <Text
                        as="b"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        fontFamily="sans-serif"
                      >
                        Remark-{quickBill.remark}
                      </Text>
                    ) : (
                      ""
                    )}
                  </Box>
                  <CardFooter
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    p={2}
                    textAlign="center"
                  >
                    {/* <h4 ><b>Cash is not refundable</b></h4> */}
                    <Text as="b">Thank You</Text>
                    <Text as="b">Visit again</Text>
                  </CardFooter>
                </Card>
              </Box>
            )
          ) : (
            ""
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export default RestaurentData;
